import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  SecurityContext,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ValidValuesService } from '../../../modules/configuration/valid-values/valid-values.service';
import { ImageUtilities } from '../../../utilities/image.utilities';
import { Globals } from '../../../globals';
import { TDOxImage } from '../models/imaging-image.model';
import { StaticDataService } from '../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { MatDialog } from '@angular/material/dialog';
import { DocumentDataModel } from '../../../models/document/document-data.model';
import { FileManagerService } from '../../../modules/file-manager/file-manager.service';
import { DocumentUploadModel } from '../../../models/document/document-upload.model';
import { RotateInteractiveModeEventArgs } from '../models/rotate-interactive-mode-event-args';
import { RotateInteractiveMode } from '../models/rotate-interactive-mode';
import { ImgProcessingInteractiveMode } from '../models/img-processing-interactive-mode';
import { ImgProcessingInteractiveModeEventArgs } from '../models/img-processing-interactive-mode-event-args';
import { TdoLeadtoolsService } from '../../../services/tdo-leadtools.service';
import { CaseTooth } from '../models/CaseTooth';
import { SignalrService } from '../../../services/socket/signalr.service';
import { DocumentTagDataModel } from '../../../models/document/document-tag-data.model';
import { DialogService } from '../../../services/dialog.service';
import { ProcessingCommandsEnum } from '../models/processing-commands.enum';
import { DocumentFileTypeEnum } from '../../../models/enum/document/document-file-type.enum';
import { DocumentTypeEnum } from '../../../models/enum/document/document-type.enum';
import { LeadtoolsResourceHelper } from './helpers/leadtools-resource.helper';
import { FileHelperService } from '../../../services/file-helper.service';
import { DocumentGroupCreationModel } from '../../../models/document/document-group-creation.model';
import { ToothPickerComponent } from '../../../modules/tdo-shared/tooth-picker/tooth-picker.component';
import { cfgTooth } from '../../../modules/tdo-shared/tooth-picker/tooth-picker.models';
import { ToothUiManagerModel } from '../../../modules/tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { CaseFormsService } from '../../../modules/case-forms/case-forms.service';
import { DocumentGroupQueryModel } from '../../../models/document/document-group-query.model';
import { DocumentClassEnum } from '../../../models/enum/document/document-class.enum';
import { ToothPickerConfigModel } from '../../../modules/tdo-shared/tooth-picker/tooth-picker-config.model';
import { ToothConfigurationModel } from '../../../models/teeth/tooth-configuration.model';
import {
  AnnotationDefaults, DrawCanvasDefaults,
  DrawFunctionDefaults,
  DrawingToolsDefaults,
  DrawMagnificationDefaults,
  DrawStampDefaults,
  DrawTextDefaults,
  LeadToolsHelper
} from '../../../models/configuration/draw/annotation-defaults.model';
import ImageProcessing = lt.ImageProcessing;
import ImageViewerSpyGlassShape = lt.Controls.ImageViewerSpyGlassShape;
import AnnObject = lt.Annotations.Engine.AnnObject;
import AnnTextObject = lt.Annotations.Engine.AnnTextObject;
import LeadPointD = lt.LeadPointD;
import LeadSizeD = lt.LeadSizeD;
import LeadRectD = lt.LeadRectD;
import AnnContainerMapper = lt.Annotations.Engine.AnnContainerMapper;
import AnnContainer = lt.Annotations.Engine.AnnContainer;
import LeadMatrix = lt.LeadMatrix;
import ImageViewer = lt.Controls.ImageViewer;
import Keys = lt.Controls.Keys;
import { MatMenuTrigger } from '@angular/material/menu';
import { DomSanitizer } from '@angular/platform-browser';
import { MessagingService } from '../../../services/messaging.service';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { ImagingTopMenuEvent } from '../imaging-top-menu/models/imaging-top-menu.event';
import { SelectDeviceDlgComponent } from '../../../modules/configuration/workstations/select-device-dlg/select-device-dlg.component';
import {
  CalibrationParameters,
  WorkstationDevicesConfigurationModel
} from '../../../models/configuration/workstation-devices-configuration.model';
import { ImagingCalibrationComponent } from '../imaging-calibration/imaging-calibration.component';
import { DevicesService } from '../../../modules/configuration/devices/devices.service';
import { DeviceConfigurationModel } from '../../../models/configuration/device-configuration.model';
import { DOCUMENT_TAG } from 'src/app/models/constants/document-tag.model';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from 'src/app/modules/auth/services/authentication.service';
import { DOC_TAG_PATIENT_PIC } from 'src/app/constants';
import { LabelService } from 'src/app/services/label.service';
import { FormattedLabelEnum } from 'src/app/models/enum/labels/formatted-label.enum';
import { ChangeImageDateDialogComponent } from '../../../modules/imaging/change-image-date-dialog/change-image-date-dialog.component';
import { UiService } from 'src/app/services/ui.service';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { OwnedObjectUrl } from './owned-object-url';


@Component({
  standalone: false,
  selector: 'app-tdo-imaging-image-container',
  templateUrl: './tdo-imaging-image-container.component.html',
  styleUrls: ['./tdo-imaging-image-container.component.scss']
})

export class TdoImagingImageContainerComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('annotationContextTemplate') annotationContextTemplate: TemplateRef<any>;
  private isCalibrationInfoAvailable: boolean = true;
  private originalCanvas: HTMLCanvasElement;
  private originalImageData: string;
  private dialogCanvas: HTMLCanvasElement = null;
  leadToolsHelper: LeadToolsHelper = new LeadToolsHelper();

  constructor(private readonly validValuesService: ValidValuesService,
    private readonly dialogService: DialogService,
    private readonly staticDataService: StaticDataService,
    private readonly dialog: MatDialog,
    private readonly fileService: FileManagerService,
    private readonly signalrService: SignalrService,
    public globals: Globals,
    private readonly caseService: CaseFormsService,
    private readonly uiService: UiService,
    private readonly imageHelperService: FileHelperService,
    private readonly tdoLeadtoolsService: TdoLeadtoolsService,
    private readonly messagingService: MessagingService,
    private readonly devsService: DevicesService,
    public datePipe: DatePipe,
    private readonly san: DomSanitizer,
    private readonly authServer: AuthenticationService,
    private readonly labelService: LabelService,
    private readonly ngZone: NgZone) {
    this.imageProcessing = new lt.ImageProcessing();
    this.imageProcessing.jsFilePath = this.jsImgColorFilePath;

    // Pre-instantiate LEADTOOLS processing workers so the browser caches their scripts
    // before the first run() call. These workers are separate from the ones LEADTOOLS
    // creates internally; their only purpose is to prime the browser's worker cache.
    this._colorWorker = new Worker(this.jsImgColorFilePath);
    this._effectsWorker = new Worker(this.jsImgEffectsFilePath);
  }

  ngOnDestroy(): void {
    this._resizeObserver?.disconnect();
    this._resizeObserver = null;
    this._colorWorker?.terminate();
    this._effectsWorker?.terminate();
    this._ownedObjectUrl.revokeFinal();
  }

  private repaintWhenReady(): void {
    if (!this.imageViewer) {
      return;
    }
    const el = document.getElementById(this.ImageName);
    if (!el || el.offsetWidth <= 0 || el.offsetHeight <= 0) {
      return;
    }
    this.imageViewer.onSizeChanged();
    this.imageViewer.zoom(lt.Controls.ControlSizeMode.fit, 0.9, this.imageViewer.defaultZoomOrigin);
    this.imageViewer.invalidate(lt.LeadRectD.empty);
    this.imageViewer.invalidateItemByIndex(0);
  }

  @Input() id: string;
  @Input() xImage: TDOxImage;
  @Input() isSelected: boolean;
  @Input() blob: string;
  @Input() annotationXmlData: string;
  @Input() fileName: File;
  @Input() ImageName: string = 'TestImg';
  @Input() imageCategoryIds: string[] = [];
  @Input() toothDetailList: CaseTooth[] = [];
  @Input() isSaveAsNew: boolean = true;
  @Input() isMultipleCaseItem: boolean = false;

  @Output() imageCategoriesChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() setContrastValue: EventEmitter<number> = new EventEmitter<number>();
  @Output() setBrightnessValue: EventEmitter<number> = new EventEmitter<number>();
  @Output() setGammaValue: EventEmitter<number> = new EventEmitter<number>();
  @Output() uploadImage: EventEmitter<object> = new EventEmitter<object>();
  // @Output() saveOriginalImage: EventEmitter<object> = new EventEmitter<object>();
  @Output() close = new EventEmitter<string>();
  @Output() maximize = new EventEmitter<TdoImagingImageContainerComponent>();
  @Output() selected = new EventEmitter<TdoImagingImageContainerComponent>();
  @Output() imageSaved = new EventEmitter<TdoImagingImageContainerComponent>();
  @Output() editTags = new EventEmitter<DocumentDataModel>();
  @Output() originalImageLoaded = new EventEmitter<HTMLImageElement>();
  @Output() toothSelectorUpdate = new EventEmitter<void>();
  @Output() imageDoubleClicked = new EventEmitter<boolean>();
  @Output() continuousXray = new EventEmitter<boolean>();
  @Output() stopFreehandRotation = new EventEmitter<boolean>();

  automation: lt.Annotations.Automation.AnnAutomation;
  manager: lt.Annotations.Automation.AnnAutomationManager;
  imageViewer = Globals.imageViewer;
  categoryList: Array<{ Name: string, ItemDisplayValue: string, ValidValueItemId: string }>;
  categories: string[];
  listcategories: any;
  idxForGeneralCat: number;
  jsImgColorFilePath = 'assets/leadtools/Leadtools.ImageProcessing.Color.js';
  jsImgEffectsFilePath = 'assets/leadtools/Leadtools.ImageProcessing.Effects.js';

  private _colorWorker: Worker | null = null;
  private _effectsWorker: Worker | null = null;
  private _resizeObserver: ResizeObserver | null = null;
  private readonly _ownedObjectUrl = new OwnedObjectUrl();
  xmlData: string;
  annRenderingEngine: lt.Annotations.Engine.AnnRenderingEngine;
  codecs: lt.Annotations.Engine.AnnCodecs;
  renderingEngine: lt.Annotations.Rendering.AnnHtml5RenderingEngine;
  defaultStroke: lt.Annotations.Engine.AnnStroke;
  defaultBrush: lt.Annotations.Engine.AnnSolidColorBrush;
  currentDrawTextDefaults: DrawTextDefaults;
  currentDrawStampDefaults: DrawStampDefaults;
  currentDrawDefaults: AnnotationDefaults;
  currentDrawToolsDefaults: DrawingToolsDefaults;
  currentDrawFunctionToolsDefaults: DrawFunctionDefaults;
  currentDrawMagnificationToolsDefaults: DrawMagnificationDefaults;
  currentDrawViewDetailDefaults: DrawMagnificationDefaults;
  currentDrawCanvasDefaults: DrawCanvasDefaults;
  // mtm review line below
  currentAnnotationDefaults = Globals.annotationsDefaults;
  fontStyles = lt.Annotations.Engine.AnnFontStyle;
  automationInteractiveMode: any;
  contextInteractiveMode: lt.Demos.Annotations.AutomationContextInteractiveMode;
  panZoomInteractiveMode: lt.Controls.ImageViewerPanZoomInteractiveMode;
  magnifyInteractiveMode: lt.Controls.ImageViewerMagnifyGlassInteractiveMode;
  zoomToInteractiveMode: lt.Controls.ImageViewerZoomToInteractiveMode;
  spyGlassInteractiveMode: lt.Controls.ImageViewerMagnifyGlassInteractiveMode;
  // spyGlassInteractiveMode: lt.Controls.ImageViewerSpyGlassInteractiveMode;
  zoomAtInteractiveMode: lt.Controls.ImageViewerZoomAtInteractiveMode;
  rubberBandMode: lt.Controls.ImageViewerRubberBandInteractiveMode;
  automationTextArea: lt.Demos.Annotations.AutomationTextArea;
  // If true, verify the mimetype of an uploaded document before loading it to ensure it's acceptable.
  verifyUploadedMimeTypes: boolean = true;
  // load LEADDocument type(Service, Local, Local Then Serivce)
  loadDocumentMode: lt.Document.DocumentLoadMode = lt.Document.DocumentLoadMode.service;
  // Last successful load options
  loadDocumentOptions: lt.Document.LoadDocumentOptions = new lt.Document.LoadDocumentOptions();
  rotateInteractiveMode: RotateInteractiveMode;
  imgProcessingInteractiveMode: ImgProcessingInteractiveMode;
  rect: lt.LeadRectD;
  imgblob: Blob;
  origBlob: Blob;
  angle: number;
  bCrop: boolean;
  rotate: boolean;
  bCtrlKeyDown: boolean;
  enumDocumentFileTypeIdJPG: string;
  docClassId: string;
  file: any;
  xmlfile: any;
  hasAnnotation: boolean = false;
  thumbnail: boolean = true;
  createdThumbnailUrl: string;
  parentDocId = null;
  document: DocumentDataModel;
  originalImage: HTMLImageElement;

  documentTagList: EnumValidValueItemModel[];
  width: number = 0;
  height: number = 0;
  isViewerVisible: boolean = true;
  isWidthMaximize: boolean = true;
  isLoading = false;
  // Set when the authenticated image download fails; drives the in-viewer fallback + Retry.
  imageLoadErrorMessage: string | null = null;
  imageProcessing: lt.ImageProcessing = null;
  contextmenu = false;
  contextmenuX = 0;
  contextmenuY = 0;
  isRuler = false;
  sourceLength: number;
  rulerLength: number;
  calibrationParam: CalibrationParameters;
  deviceList: DeviceConfigurationModel[];
  isSaving: boolean = false;
  isDisabled: boolean = false;
  isRotation: boolean = false;

  // Operation errors, so we do not show an alert for the same type of errors twice
  private _operationErrors: lt.Document.Viewer.DocumentViewerOperation[];
  private _loadDocumentAnnotationsFile: any = null;
  private _originalImageEmitted = false;

  @HostListener('resize', ['$event'])
  onResize(event) {
    this.imageViewerSizeChanged();
  }

  ngAfterViewInit(): void {
    this.tdoLeadtoolsService.verifyService();
    this.initLeadtoolsControls();
    this.document = this.xImage.loadedDocument;
    if (this.xImage.imageSource === 'FolderMonitor') {
      // if(this.document === null || this.document === undefined) {
      this.document = new DocumentDataModel();
      this.document.DocumentID = this.xImage.DocumentId;
      this.document.dataDocumentTags = [];
      for (const tag of this.xImage.Categories) {
        const cat = this.documentTagList.find(p => p.ValidValueItemId.toUpperCase() === tag.toUpperCase());
        const docTag = new DocumentTagDataModel();
        docTag.enumDocumentTag = cat;
        docTag.DocumentID = this.xImage.DocumentId;
        docTag.enumDocumentTagID = tag;
        this.document.dataDocumentTags.push(docTag);
      }
      //}
    }
    this.onAnnotationChange(lt.Annotations.Engine.AnnTextObject.freehandObjectId);

    // ResizeObserver fires at the exact moment the container gains real dimensions —
    // more reliable than setTimeout guesses. When both width and height are > 0,
    // tell LeadTools the container changed size and repaint.
    const viewerEl = document.getElementById(this.ImageName);
    if (viewerEl) {
      this._resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { width, height } = entry.contentRect;
          if (width > 0 && height > 0 && this.imageViewer) {
            this.ngZone.runOutsideAngular(() => this.repaintWhenReady());
          }
        }
      });
      this._resizeObserver.observe(viewerEl);
    }
  }

  ngOnInit(): void {
    if (this.xImage.imageSource !== 'FolderMonitor') {
      this.getCalibrationData();
      // if it's a new document select all teeth
      if (this.xImage.DocumentId == null) {
        const teeth: string[] = [];
        this.xImage.selectedTeeth = [];
        if (this.toothDetailList) {
          for (const item of this.toothDetailList) {
            this.xImage.selectedTeeth.push(item);
          }
        }
        for (const t of this.xImage.selectedTeeth) {
          const model = new DocumentGroupCreationModel();
          model.ParentObjectName = 'dataPatientCaseWorkItemTeeth';
          model.ObjectId = t.CaseWorkItemToothId;
          model.documentIds = [this.xImage.DocumentId];
          model.PatientId = this.globals.currentPatientId;
          this.fileService.createDocumentGroup(model).subscribe((res) => {
            //
          });
        }
      } else {
        this.getAssociatedTeeth();
      }
    }


    this.idxForGeneralCat = 0;
    this.listcategories = -1;
    this.bCtrlKeyDown = false;

    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => this.documentTagList = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag')
      });
    } else {
      this.documentTagList = this.staticDataService.getValidValueItemsByValidValueName('enumDocumentTag');
    }
  }
  async getAssociatedTeeth() {
    if (!this.xImage || !this.xImage.loadedDocument) {
      return;
    }

    const mod = new DocumentGroupQueryModel();
    mod.ParentObjectName = 'dataPatientCaseWorkItemTeeth';
    mod.DocumentId = this.xImage.loadedDocument.DocumentID;
    mod.PatientId = this.globals.currentPatientId;

    const res = await this.fileService.getGroupsForDocument(mod).toPromise();


    if (res && res.length > 0) {
      this.xImage.selectedTeeth = [];
      const teeth: CaseTooth[] = [];
      const objectIds = res.map(p => p.ObjectId);
      for (const t of this.toothDetailList) {
        if (objectIds.includes(t.CaseWorkItemToothId)) {
          teeth.push(t);
        }
      }
      // if image is linked to a different caseworkitem, get the teeth from the DocumentId
      if (teeth.length === 0) {

        const res2 = await this.fileService.getTeethByDocumentId(this.xImage.loadedDocument.DocumentID).toPromise();

        if (res2) {
          this.toothDetailList = res2;
          for (const t of this.toothDetailList) {
            if (objectIds.includes(t.CaseWorkItemToothId)) {
              teeth.push(t);
            }
          }
          this.isDisabled = true;
        }

      }

      this.xImage.selectedTeeth = teeth;
    }

  }

  getAssociatedTeethkeep() {
    if (!this.xImage || !this.xImage.loadedDocument) {
      return;
    }

    const mod = new DocumentGroupQueryModel();
    mod.ParentObjectName = 'dataPatientCaseWorkItemTeeth';
    mod.DocumentId = this.xImage.loadedDocument.DocumentID;
    mod.PatientId = this.globals.currentPatientId;
    this.fileService.getGroupsForDocument(mod).subscribe((res) => {
      if (res && res.length > 0) {
        this.xImage.selectedTeeth = [];
        const teeth: CaseTooth[] = [];
        const objectIds = res.map(p => p.ObjectId);
        for (const t of this.toothDetailList) {
          if (objectIds.includes(t.CaseWorkItemToothId)) {
            teeth.push(t);
          }
        }
        // if image is linked to a different caseworkitem, get the teeth from the DocumentId
        if (teeth.length === 0) {
          this.fileService.getTeethByDocumentId(this.xImage.loadedDocument.DocumentID).subscribe((res) => {
            if (res) {
              this.toothDetailList = res;
              for (const t of this.toothDetailList) {
                if (objectIds.includes(t.CaseWorkItemToothId)) {
                  teeth.push(t);
                }
              }
              this.isDisabled = true;
            }
          });
        }

        setTimeout(() => {
          this.xImage.selectedTeeth = teeth;
        }, 500);
      }
    });
  }

  // Leadtools initialization
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  initLeadtoolsControls() {
    const propertyChangedText: HTMLElement = document.getElementById('propertyChanged') as HTMLElement;
    const imageViewerDiv = document.getElementById(this.ImageName) as HTMLSelectElement;
    // Create the image viewer inside it
    const createOptions = new lt.Controls.ImageViewerCreateOptions(imageViewerDiv);
    this.imageViewer = new lt.Controls.ImageViewer(createOptions);

    this.imageViewer.viewVerticalAlignment = lt.Controls.ControlAlignment.center;
    this.imageViewer.viewHorizontalAlignment = lt.Controls.ControlAlignment.center;
    this.imageViewer.autoCreateCanvas = true;

    this.imageViewer.zoom(lt.Controls.ControlSizeMode.fit, 0.9, this.imageViewer.defaultZoomOrigin);
    // Create and set up the automation manager using the HTML5 rendering engine
    this.renderingEngine = new lt.Annotations.Rendering.AnnHtml5RenderingEngine();
    this.manager = lt.Annotations.Automation.AnnAutomationManager.create(
      this.renderingEngine
    );
    this.manager.editObjectAfterDraw = false;

    this.currentDrawTextDefaults = this.xImage.drawTextDefaults;
    this.currentDrawStampDefaults = this.xImage.drawStampDefaults;
    this.currentDrawDefaults = this.xImage.annotationsDefaults;
    this.currentDrawToolsDefaults = this.xImage.drawToolsDefaults;
    this.currentDrawFunctionToolsDefaults = this.xImage.drawFunctionToolsDefaults;
    this.currentDrawMagnificationToolsDefaults = this.xImage.drawMagnificationDefaults;
    this.currentDrawViewDetailDefaults = this.xImage.drawViewDetailDefaults;
    this.currentDrawCanvasDefaults = this.xImage.drawCanvasDefaults;
    this.createLeadtoolsAnnotations();


    const userMode = document.getElementById('userMode') as HTMLSelectElement;
    // Hook to its change event
    userMode.addEventListener('change', () => {
      // Get the selected mode
      const mode = userMode.options[userMode.selectedIndex].innerHTML;
      if (mode === 'Design') {
        this.manager.userMode = lt.Annotations.Engine.AnnUserMode.design;
      } else {
        this.manager.userMode = lt.Annotations.Engine.AnnUserMode.run;
      }
    });
    // Create an instance of the Automation control object that works with LEADTOOLS ImageViewer
    const automationControl = new lt.Demos.Annotations.ImageViewerAutomationControl();
    // this.automationControl = new lt.Demos.Annotations.ImageViewerAutomationControl();
    // Attach our image viewer
    automationControl.imageViewer = this.imageViewer;

    // Set the image viewer interactive mode
    // @ts-ignore
    // const automationInteractiveMode = new lt.Demos.Annotations.AutomationInteractiveMode();
    this.automationInteractiveMode = new lt.Demos.Annotations.AutomationInteractiveMode();
    this.automationInteractiveMode.automationControl = automationControl;
    // this.automationInteractiveMode.idleCursor = 'move';
    this.automationInteractiveMode.workingCursor = 'crosshair';

    // Right click
    this.contextInteractiveMode = new lt.Demos.Annotations.AutomationContextInteractiveMode();
    this.contextInteractiveMode.context.add((sender: any, e: lt.Demos.Viewer.ContextEventArgs) => this.automation_onShowContextMenu(sender, e));
    this.contextInteractiveMode.mouseButtons = lt.Controls.MouseButtons.right;

    this.addInteractiveMode();

    this.imageViewer.defaultInteractiveMode = this.automationInteractiveMode;
    if (this.imageViewer.defaultInteractiveMode.id === 1) { // if we are using the Pan/Zoom interactive mode.
      const zoomSettings = new lt.Controls.ImageViewerPanZoomInteractiveMode();
      zoomSettings.isKeyboardEnabled = false; // don't use keyboard for zooming
      zoomSettings.zoomKeyModifier = 0; // remove requirement to use Ctrl key to zoom
      zoomSettings.enablePan = false; // only allow zoom, not panning
      zoomSettings.set_isDragMouseWheelEnabled(true);
      zoomSettings.enableZoom = true;
      this.imageViewer.defaultInteractiveMode = zoomSettings; // set interactive mode to viewer.
    }

    this.automation = new lt.Annotations.Automation.AnnAutomation(
      this.manager,
      automationControl
    );

    // Set rightclick interactive mode automation
    this.contextInteractiveMode.automation = this.automation;

    this.automation.editText.add((sender: any, e: lt.Annotations.Engine.AnnEditTextEventArgs) => this.automation_EditText(sender, e));

    this.codecs = new lt.Annotations.Engine.AnnCodecs();
    if (this.annotationXmlData) {
      fetch(this.annotationXmlData, {
        method: 'GET', // or 'POST', 'PUT', etc.
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('TDOauthToken')}`
        }})
        .then(response => response.text())
        .then(data => {
          this.automation.attachContainer(this.codecs.load(data, 1), null);
        });
    }
    // Add handler to update the container size when the image size changes
    this.imageViewer.itemChanged.add((sender, e) => {
      const container = this.automation.container;
      container.size = container.mapper.sizeToContainerCoordinates(
        this.imageViewer.imageSize
      );
    });
    this.imageViewer.imageLoading.add((sender, e) => {
      e.imageLoader.add_done(() => {
        const imgSize = this.imageViewer?.imageSize;
        // Emit originalImageLoaded from imageViewer.imageSize so MDI item gets resized
        // before repaint, instead of waiting for imageViewerGetBlob's HTTP request.
        if (imgSize && imgSize.width > 0 && imgSize.height > 0 && !this._originalImageEmitted) {
          this._originalImageEmitted = true;
          const synth = new Image();
          synth.width = imgSize.width;
          synth.height = imgSize.height;
          this.originalImage = synth;
          this.ngZone.run(() => this.originalImageLoaded.emit(synth));
        }
        this.ngZone.runOutsideAngular(() => this.repaintWhenReady());
      });
    });
    // set up this automation as the active one
    this.automation.active = true;
    // Hook to the run even so we know when an object enters run mode
    this.automation.run.add((sender, e) => {
      // e is of type AnnRunDesignerEventArgs
      if (e.operationStatus === lt.Annotations.Engine.AnnDesignerOperationStatus.start) {
        //
      }
    });

    // Optional: Add the resources to the automation manager
    this.addResources(this.manager);

    // Load an image
    // console.log('initLeadtoolsControls fileName ', this.fileName);
    if (!this.fileName) {
      // if (this.xImage.imageSource === 'BlankCanvas')
      if (this.xImage.imageSource.includes('Canvas')) {
        this.imageViewerGetBlob4BlankImage(() => {

          this.originalImageLoaded.emit(this.originalImage);
          const intervalSubscription2 = setInterval(() => {
            this.origBlob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
            if (this.origBlob) {
              clearInterval(intervalSubscription2);
            }
          }, 100);
        });
      }
      // else {
      this.ngZone.runOutsideAngular(async () => {
        // console.log('Loading this.xImage.URL', this.xImage.URL);
        if (this.xImage.URL) {
          if (this.xImage.imageSource === 'FolderMonitor') {
            // To convert SafeResourceUrl to string sanitize the SafeResourceUrl again with sanitize() method whose return value is
            // string | null. (https://stackoverflow.com/questions/55849415/type-saferesourceurl-is-not-assignable-to-type-string)
            // line below was how it was before changes by Cline
            this.imageViewer.imageUrl = this.san.sanitize(SecurityContext.RESOURCE_URL, this.san.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.xImage.URL));
            // Next 2 lines were Cline's changes Create a blob from the base64 data and use URL.createObjectURL to avoid 414 error (Request-URI Too Large)
            // const imageBlob = ImageUtilities.base64ToBlob(this.xImage.URL, 'image/jpeg');
            // this.imageViewer.imageUrl = URL.createObjectURL(imageBlob);
            this.showAssignedImage();
          } else {
            await this.loadImageFromAuthenticatedUrl(this.xImage.URL);
          }
        }
      });
      if (this.blob) {
        // console.log('Loading this.blob', this.blob);
        // from cache
        const myblob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
        this._ownedObjectUrl.assignToViewer(myblob, this.imageViewer);
        // console.log('Loading this.imageViewer.imageUrl', this.imageViewer.imageUrl);
        // this.uploadBlob(myblob);
      }
    }
    else {
      const intervalSubscription = setInterval(_ => {

        // console.log('Loading this.fileName from intervalSubscription', this.fileName);
        this._ownedObjectUrl.assignToViewer(this.fileName, this.imageViewer);
        // console.log('Loading this.imageViewer.imageUrl from intervalSubscription', this.imageViewer.imageUrl);
        if (this.imageViewer.imageUrl) {
          clearInterval(intervalSubscription);
          this.imageViewerGetBlob(() => {

            this.originalImageLoaded.emit(this.originalImage);
            const intervalSubscription2 = setInterval(() => {
              this.origBlob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
              if (this.origBlob) {
                clearInterval(intervalSubscription2);
                if (!this.xImage.bImageSaved) {
                  this.autoSaveImage(() => {
                    // console.log('TdoImagingImageContainerComponent autosave completed');
                  });
                }
              }
            }, 100);
          });
        }
      }, 100);
    }
  }

  /**
   * Downloads the image through the authenticated HTTP client and hands it to the viewer.
   * A failed download (expired session, deleted file, network) used to reject silently,
   * leaving the viewer stuck in its loading state. Instead the failure is surfaced with an
   * actionable message and the viewer is left untouched so the user can retry.
   */
  async loadImageFromAuthenticatedUrl(url: string): Promise<void> {
    let blob: Blob;
    try {
      blob = await firstValueFrom(this.fileService.downloadFileData(url));
    } catch (error) {
      console.error('Failed to download image data.', url, error);
      this.ngZone.run(() => {
        this.imageLoadErrorMessage = this.getImageDownloadErrorMessage(error);
        this.uiService.displayMessage('Error', this.imageLoadErrorMessage);
      });
      return;
    }

    this._ownedObjectUrl.assignToViewer(blob, this.imageViewer);
    if (this.xImage.imageSource === 'Twain') {
      this.ngZone.run(() => this.continuousXray.emit(true));
    }
    this.showAssignedImage();
  }

  retryImageLoad(): void {
    const url = this.xImage?.URL;
    if (!url) {
      return;
    }
    this.imageLoadErrorMessage = null;
    this.ngZone.runOutsideAngular(() => this.loadImageFromAuthenticatedUrl(url));
  }

  private showAssignedImage(): void {
    this.imageViewer.clipImageToContent = true;
    this.loadImageInViewer();
  }

  private getImageDownloadErrorMessage(error: unknown): string {
    const status = error instanceof HttpErrorResponse ? error.status : undefined;
    if (status === 401 || status === 403) {
      return 'You are not authorized to view this image. Sign in again, then click Retry.';
    }
    if (status === 404) {
      return 'This image could not be found on the server. It may have been moved or deleted.';
    }
    return 'The image could not be downloaded. Check your connection, then click Retry.';
  }

  loadImageInViewer() {
    const intervalSubscription = setInterval(() => {
      // Do NOT reassign imageUrl here — it was already set in initLeadtoolsControls()
      // and reassigning restarts LeadTools' internal async load, creating a race with invalidate().
      if (this.imageViewer.imageUrl) {
        clearInterval(intervalSubscription);
        this.imageViewerGetBlob(() => {
          if (!this.originalImage) {
            const synth = new Image();
            const imgSize = this.imageViewer?.imageSize;
            synth.width = imgSize?.width || 0;
            synth.height = imgSize?.height || 0;
            this.originalImage = synth;
          }
          this.width = this.originalImage.width;
          this.height = this.originalImage.height;
          if (!this._originalImageEmitted) {
            this._originalImageEmitted = true;
            this.originalImageLoaded.emit(this.originalImage);
          }
          const intervalSubscription2 = setInterval(_ => {
            this.origBlob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
            if (this.origBlob) {
              clearInterval(intervalSubscription2);
              if (!this.xImage.bImageSaved) {
                this.autoSaveImage(() => {
                  // this.signalrService.messageAllUsers(SignalrService.UPDATE_DOCUMENT, this.globals.currentPatient);
                });
              }
            }
          }, 100);
        });
      }
    }, 100);
  }


  createLeadtoolsAnnotations() {
    // Create the default annotations objects
    this.manager.createDefaultObjects();
    this.manager.editTextAfterDraw = true;
    this.manager.fontRelativeToImageDpi = false;

    const currentObject = document.getElementById('currentObject') as HTMLSelectElement;
    const automationObjCount = this.manager.objects.count;
    for (let i = 0; i < automationObjCount; i++) {
      // Get the object
      const automationObj = this.manager.objects.item(i);
      const annObjectTemplate = automationObj.objectTemplate;

      if (annObjectTemplate != null) {
        // Set the object draw cursor
        // automationObj.drawCursor = this.managerHelper.getAutomationObjectCursor(automationObj.id) || "crosshair";
        // if (automationObj.name === "Pointer") {
        if (annObjectTemplate instanceof lt.Annotations.Engine.AnnPolylineObject) {
          // Create arrow line ending style and set some properties
          const arrowStyle: lt.Annotations.Engine.AnnArrowLineEnding = new lt.Annotations.Engine.AnnArrowLineEnding();
          if (this.currentDrawToolsDefaults.useRatioArrowLen === false) {
            arrowStyle.length = lt.LeadLengthD.create(this.currentDrawToolsDefaults.arrowLength);
          }
          if (this.currentDrawToolsDefaults.fillArrowhead) {
            arrowStyle.closed = true;
            arrowStyle.fill = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawDefaults.fillColor);
          }
          else {
            arrowStyle.closed = false;
          }
          //    //arrowStyle.reversed = true;
          //    //arrowStyle.fill = lt.Annotations.Engine.AnnSolidColorBrush.create("Yellow");
          // Set the created arrow style to polyline start and end style
          // annObjectTemplate.startStyle = arrowStyle;
          // annObjectTemplate.endStyle = arrowStyle;
        }
        // }
        if (annObjectTemplate.supportsStroke) {
          // tslint:disable-next-line:max-line-length
          const stroke = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawDefaults.strokeColor),
            lt.LeadLengthD.create(this.currentDrawDefaults.strokeWidth));
          // var stroke = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create('green'), lt.LeadLengthD.create(2));
          switch (this.currentDrawDefaults.lineEndCap) {
            case lt.Annotations.Engine.AnnStrokeLineCap.flat:
              stroke.strokeEndLineCap = lt.Annotations.Engine.AnnStrokeLineCap.flat;
              break;
            case lt.Annotations.Engine.AnnStrokeLineCap.round:
              stroke.strokeEndLineCap = lt.Annotations.Engine.AnnStrokeLineCap.round;
              break;
            case lt.Annotations.Engine.AnnStrokeLineCap.triangle:
              stroke.strokeEndLineCap = lt.Annotations.Engine.AnnStrokeLineCap.triangle;
              break;
            case lt.Annotations.Engine.AnnStrokeLineCap.square:
              stroke.strokeEndLineCap = lt.Annotations.Engine.AnnStrokeLineCap.square;
              break;
          }
          switch (this.currentDrawDefaults.lineStartCap) {
            case lt.Annotations.Engine.AnnStrokeLineCap.flat:
              stroke.strokeStartLineCap = lt.Annotations.Engine.AnnStrokeLineCap.flat;
              break;
            case lt.Annotations.Engine.AnnStrokeLineCap.round:
              stroke.strokeStartLineCap = lt.Annotations.Engine.AnnStrokeLineCap.round;
              break;
            case lt.Annotations.Engine.AnnStrokeLineCap.triangle:
              stroke.strokeStartLineCap = lt.Annotations.Engine.AnnStrokeLineCap.triangle;
              break;
            case lt.Annotations.Engine.AnnStrokeLineCap.square:
              stroke.strokeStartLineCap = lt.Annotations.Engine.AnnStrokeLineCap.square;
              break;
          }
          annObjectTemplate.stroke = stroke;

          if (annObjectTemplate instanceof lt.Annotations.Engine.AnnPolyRulerObject) {
            // var polyRuler = <lt.Annotations.Engine.AnnPolyRulerObject>annObjectTemplate;
            annObjectTemplate.showTickMarks = this.currentDrawFunctionToolsDefaults.showTickMarks;
            annObjectTemplate.showGauge = this.currentDrawFunctionToolsDefaults.showGauge;
            annObjectTemplate.tickMarksStroke = stroke;
            // console.log('mtm isCalibrationInfoAvailable ', this.isCalibrationInfoAvailable);
            if (this.isCalibrationInfoAvailable === false) {
              lt.Annotations.Engine.AnnUnitConverter.customUnitAbbreviation = 'No Calibration';
              lt.Annotations.Engine.AnnUnitConverter.customUnitPerInch = 1;
              annObjectTemplate.measurementUnit = lt.Annotations.Engine.AnnUnit.customUnit;
            } else {
              annObjectTemplate.measurementUnit = lt.Annotations.Engine.AnnUnit.millimeter;
            }
            annObjectTemplate.font = new lt.Annotations.Engine.AnnFont(this.currentDrawFunctionToolsDefaults.fontName,
              this.currentDrawFunctionToolsDefaults.fontSize);
            // annObjectTemplate.fill = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawFunctionToolsDefaults.background);
            annObjectTemplate.labels.RulerLength.foreground =
              lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawFunctionToolsDefaults.foreground);
            // mtm - figure out a way to make the background txt transparent
            // annObjectTemplate.labels.RulerLength.background = 'Transparent';
            // annObjectTemplate.labels.RulerLength.background =
            //  lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawFunctionToolsDefaults.background);
          }
          if (annObjectTemplate instanceof lt.Annotations.Engine.AnnTextObject) {
            annObjectTemplate.textForeground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.foregroundTxt);
            annObjectTemplate.text = 'Example Text';
            annObjectTemplate.font.fontSize = this.currentDrawTextDefaults.fontSizeTxt;
            // annObjectTemplate.font.fontSize = newFontSize;
/*

            annObjectTemplate.font = new lt.Annotations.Engine.AnnFont(this.currentDrawTextDefaults.fontNameTxt,
              this.currentDrawTextDefaults.fontSizeTxt);

*/

            // annObjectTemplate.font.fontStyle = this.fontStyles[this.currentDrawTextDefaults.fontStyleTxt];
            switch (this.currentDrawTextDefaults.fontStyleTxt) {
              case 'Regular':
                annObjectTemplate.font.fontStyle = 0;
                break;
              case 'Bold':
                annObjectTemplate.font.fontWeight = lt.Annotations.Engine.AnnFontWeight.bold;
                break;
              case 'Italic':
                annObjectTemplate.font.fontStyle = 1;
                break;
              case 'Underline':
                annObjectTemplate.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.underline;
                break;
              case 'Strikethrough':
                annObjectTemplate.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.strikethrough;
                break;
            }
            let strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create('Transparent'),
              lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxt));
            if (this.currentDrawTextDefaults.borderColorTxt !== 'Transparent') {
              strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.borderColorTxt),
                lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxt));
            }
            annObjectTemplate.stroke = strokeTxt;
          }
          if (annObjectTemplate instanceof lt.Annotations.Engine.AnnTextPointerObject) {
            annObjectTemplate.textForeground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.foregroundTxtPtr);
            if (this.currentDrawTextDefaults.backgroundTxtPtr !== 'Transparent') {
              annObjectTemplate.textBackground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.backgroundTxtPtr);
            }
            // annObjectTemplate.textBackground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.backgroundTxtPtr);
            annObjectTemplate.text = 'Pointer Text';
            annObjectTemplate.font.fontSize = 48;
            annObjectTemplate.font.fontSize = this.currentDrawTextDefaults.fontSizeTxtPtr * 2;

            // annObjectTemplate.font.fontStyle = this.fontStyles[this.currentDrawTextDefaults.fontStyleTxt];
            switch (this.currentDrawTextDefaults.fontStyleTxtPtr) {
              case 'Regular':
                annObjectTemplate.font.fontStyle = 0;
                break;
              case 'Bold':
                annObjectTemplate.font.fontWeight = lt.Annotations.Engine.AnnFontWeight.bold;
                break;
              case 'Italic':
                annObjectTemplate.font.fontStyle = 1;
                break;
              case 'Underline':
                annObjectTemplate.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.underline;
                break;
              case 'Strikethrough':
                annObjectTemplate.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.strikethrough;
                break;
            }
            let strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.borderColorTxtPtr),
              lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxtPtr));
            /*
                        let strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create('Transparent'),
                          lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxtPtr));
                        if (this.currentDrawTextDefaults.borderColorTxt !== 'Transparent') {
                          strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.borderColorTxtPtr),
                            lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxtPtr));
                        }
            */
            annObjectTemplate.stroke = strokeTxt;
          }

          if (annObjectTemplate instanceof lt.Annotations.Engine.AnnStampObject) {
            annObjectTemplate.textForeground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawStampDefaults.foregroundStdStamp);
            annObjectTemplate.text = 'Example Text';
            // const font = new lt.Annotations.Engine.AnnFont(this.currentAnnotationDefaultsTmp.fontTxt, this.currentAnnotationDefaultsTmp.fontSizeTxt);
            // var font = new lt.Annotations.Engine.AnnFont("Arial", 12);
            // font.fontStyle = this.fontStyles[this.currentAnnotationDefaults.fontStyle];
            // font.fontStyle = lt.Annotations.Engine.AnnFontStyle.normal;
            // annObjectTemplate.font = new lt.Annotations.Engine.AnnFont(this.currentAnnotationDefaultsTmp.fontTxt, this.currentAnnotationDefaultsTmp.fontSizeTxt);
            annObjectTemplate.font = new lt.Annotations.Engine.AnnFont(this.currentDrawStampDefaults.fontNameStdStamp, this.currentDrawStampDefaults.fontSizeStdStamp);
            switch (this.currentDrawStampDefaults.fontStyleStdStamp) {
              case 'Regular':
                annObjectTemplate.font.fontStyle = 0;
                break;
              case 'Bold':
                annObjectTemplate.font.fontWeight = lt.Annotations.Engine.AnnFontWeight.bold;
                break;
              case 'Italic':
                annObjectTemplate.font.fontStyle = 1;
                break;
              case 'Underline':
                annObjectTemplate.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.underline;
                break;
              case 'Strikethrough':
                annObjectTemplate.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.strikethrough;
                break;
            }
          }
        }
      }

      // Add its name to the select element
      const name = automationObj.name;
      const id = automationObj.id;
      currentObject.options[currentObject.options.length] = new Option(name, id.toString());
    }

    // When the current object ID changes, we need to update our select
    this.manager.currentObjectIdChanged.add((sender, e) => {
      this.imageViewerSizeChanged();
      const currentObjectId = this.manager.currentObjectId;
      // console.log('CurrentObjectId: ' + currentObjectId);
      for (let i = 0; i < currentObject.options.length; i++) {
        const id = parseInt(currentObject.options[i].value);
        if (id === currentObjectId) {
          currentObject.selectedIndex = i;
          // console.log('Selected index: ' + currentObject.selectedIndex);
          break;
        }
      }
    });

    currentObject.selectedIndex = 1;
  }

  addInteractiveMode() {
    // Pan/Zoom
    this.panZoomInteractiveMode = new lt.Controls.ImageViewerPanZoomInteractiveMode();
    this.panZoomInteractiveMode.idleCursor = 'move';
    this.panZoomInteractiveMode.workingCursor = 'pointer';
    this.panZoomInteractiveMode.zoomKeyModifier = Keys.none;

    // Magnifying glass
    this.magnifyInteractiveMode = new lt.Controls.ImageViewerMagnifyGlassInteractiveMode();
    if (this.currentDrawMagnificationToolsDefaults?.hasCrosshairs) {
      this.magnifyInteractiveMode.crosshair = lt.Controls.ImageViewerSpyGlassCrosshair.fine;
    }
    else {
      this.magnifyInteractiveMode.crosshair = lt.Controls.ImageViewerSpyGlassCrosshair.none;
    }
    this.magnifyInteractiveMode.idleCursor = 'crosshair';
    this.magnifyInteractiveMode.workingCursor = 'crosshair';
    this.magnifyInteractiveMode.crosshairColor = this.currentDrawMagnificationToolsDefaults?.crosshairsColor ?? 'black';
    this.magnifyInteractiveMode.crosshairThickness = this.currentDrawMagnificationToolsDefaults?.crosshairWidth ?? 2;
    const magnifyGlassSize = new lt.LeadSizeD();
    magnifyGlassSize.width = this.currentDrawMagnificationToolsDefaults?.width ?? 500;
    magnifyGlassSize.height = this.currentDrawMagnificationToolsDefaults?.height ?? 500;
    this.magnifyInteractiveMode.size = magnifyGlassSize;
    this.magnifyInteractiveMode.backgroundColor = this.currentDrawMagnificationToolsDefaults?.borderColor ?? 'black';
    this.magnifyInteractiveMode.borderThickness = this.currentDrawMagnificationToolsDefaults?.borderWidth ?? 2;
    switch (this.currentDrawMagnificationToolsDefaults?.shape) {
      case 'Rectangle':
        this.magnifyInteractiveMode.shape = ImageViewerSpyGlassShape.rectangle;
        break;
      case 'RoundRectangle':
        this.magnifyInteractiveMode.shape = ImageViewerSpyGlassShape.roundRectangle;
        break;
      case 'Ellipse':
        this.magnifyInteractiveMode.shape = ImageViewerSpyGlassShape.ellipse;
        break;
    }
    this.magnifyInteractiveMode.scaleFactor = this.currentDrawMagnificationToolsDefaults?.scaleFactor ?? 2;

    // this.panZoomInteractiveMode.idleCursor = "move";
    // this.panZoomInteractiveMode.workingCursor = "pointer";

    // Zoom to Selection
    this.zoomToInteractiveMode = new lt.Controls.ImageViewerZoomToInteractiveMode();
    this.zoomToInteractiveMode.idleCursor = 'crosshair';
    this.zoomToInteractiveMode.workingCursor = 'crosshair';

    // Zoom At
    // this.zoomAtInteractiveMode = new lt.Controls.ImageViewerZoomAtInteractiveMode();
    // this.zoomAtInteractiveMode.idleCursor = "move";
    // this.zoomAtInteractiveMode.workingCursor = "pointer";

    // Spy Glass
    // this.spyGlassInteractiveMode = new lt.Controls.ImageViewerSpyGlassInteractiveMode();
    this.spyGlassInteractiveMode = new lt.Controls.ImageViewerMagnifyGlassInteractiveMode();
    this.spyGlassInteractiveMode.idleCursor = 'crosshair';
    this.spyGlassInteractiveMode.workingCursor = 'crosshair';
    this.spyGlassInteractiveMode.crosshairColor = this.currentDrawViewDetailDefaults?.crosshairsColor ?? 'black';
    this.spyGlassInteractiveMode.crosshairThickness = this.currentDrawViewDetailDefaults?.crosshairWidth ?? 2;
    const size = new lt.LeadSizeD();
    size.width = this.currentDrawViewDetailDefaults?.width ?? 500;
    size.height = this.currentDrawViewDetailDefaults?.height ?? 500;
    this.spyGlassInteractiveMode.size = size;
    this.spyGlassInteractiveMode.borderColor = this.currentDrawViewDetailDefaults?.borderColor ?? 'black';
    this.spyGlassInteractiveMode.borderThickness = this.currentDrawViewDetailDefaults?.borderWidth ?? 2;
    switch (this.currentDrawViewDetailDefaults?.shape) {
      case 'Rectangle':
        this.spyGlassInteractiveMode.shape = ImageViewerSpyGlassShape.rectangle;
        break;
      case 'RoundRectangle':
        this.spyGlassInteractiveMode.shape = ImageViewerSpyGlassShape.roundRectangle;
        break;
      case 'Ellipse':
        this.spyGlassInteractiveMode.shape = ImageViewerSpyGlassShape.ellipse;
        break;
      default:
        this.spyGlassInteractiveMode.shape = ImageViewerSpyGlassShape.rectangle;
        break;
    }
    this.spyGlassInteractiveMode.scaleFactor = 2;
    this.rubberBandMode = new lt.Controls.ImageViewerRubberBandInteractiveMode();
    this.rubberBandMode.idleCursor = 'crosshair';
    this.rubberBandMode.workingCursor = 'crosshair';
    this.rubberBandMode.rubberBandCompleted.add((sender, e) => {
      if (e.isCanceled || !this.rubberBandMode.item) {
        return;
      }

      // Get the rectangle
      this.rect = lt.LeadRectD.fromLTRB(e.points[0].x, e.points[0].y, e.points[1].x, e.points[1].y);

      // Intersect it with the control visible rectangle
      const visibleRect: lt.LeadRectD = this.imageViewer.getViewBounds(true, true);
      this.rect.intersect(visibleRect);

      // Convert it to image coordinates
      this.rect = this.imageViewer.convertRect(null, lt.Controls.ImageViewerCoordinateType.control, lt.Controls.ImageViewerCoordinateType.image, this.rect);
      if (this.rect.x < 0) {
        this.rect.x = 0;
      }
      if (this.rect.y < 0) {
        this.rect.y = 0;
      }
      // Make sure it is large enough
      if (this.rect.width > 3 && this.rect.height > 3) {
        this.uploadBlob(this.imgblob);
      }

    });

    this.rubberBandMode.autoItemMode = lt.Controls.ImageViewerAutoItemMode.autoSet;
    this.rubberBandMode.itemPart = lt.Controls.ImageViewerItemPart.image;

    /*Manual rotation*/
    // Create our custom interactive mode
    this.rotateInteractiveMode = new RotateInteractiveMode();
    // Subscribe to the rotate event and show the value
    this.rotateInteractiveMode.rotate.add((sender: any, e: RotateInteractiveModeEventArgs) => {

/*
      if (e.rotateAngle === -999) {
        this.stopRotation();
      }
*/
    });

    /*Image processing using mouse*/
    // Create our custom interactive mode
    this.imgProcessingInteractiveMode = new ImgProcessingInteractiveMode();
    // Subscribe to the rotate event and show the value
    this.imgProcessingInteractiveMode.mousemove.add((sender: any, e: ImgProcessingInteractiveModeEventArgs) => {
      // console.log('TdoImagingImageContainerComponent x, y ' + e.x + ', ' + e.y);
      if (this.bCtrlKeyDown) {
        let gammaVal: number = Number(this.xImage.gammaVal);
        const gammaFactor: number = e.y * 10;
        gammaVal = gammaVal + gammaFactor;
        this.xImage.gammaVal = gammaVal;
        this.imgGamma(this.xImage.gammaVal, this.xImage.URL);
        this.setGammaValue.emit(this.xImage.gammaVal);
      } else {
        let brightVal: number = Number(this.xImage.brightnessVal);
        brightVal = brightVal + e.y;
        let contrast: number = Number(this.xImage.contrastVal);
        contrast = contrast + e.x;
        this.xImage.brightnessVal = brightVal;
        this.xImage.contrastVal = contrast;
        const model = new TDOxImage();
        model.brightnessVal = this.xImage.brightnessVal;
        model.contrastVal = this.xImage.contrastVal;
        this.xProcessImage(ProcessingCommandsEnum.ContrastBrightnessIntensity, this.xImage.URL, model);
        // this.setBrightnessValue.emit(this.xImage.brightnessVal);
        // this.setContrastValue.emit(this.xImage.contrastVal);
      }
    });

    /*End Image processing using mouse*/
    // Add to ImageViewer
    const modes = [
      this.automationInteractiveMode,
      this.panZoomInteractiveMode,
      this.magnifyInteractiveMode,
      this.zoomToInteractiveMode,
      this.spyGlassInteractiveMode,
      this.rotateInteractiveMode,
      this.rubberBandMode,
      this.imgProcessingInteractiveMode,
      // this.spyGlassInteractiveMode,
      this.contextInteractiveMode
    ];
    this.imageViewer.interactiveModes.beginUpdate();
    for (const mode of modes) {
      mode.isEnabled = false;
      this.imageViewer.interactiveModes.add(mode);
    }

    this.automationInteractiveMode.isEnabled = true;
    this.contextInteractiveMode.isEnabled = true;
    this.imageViewer.interactiveModes.endUpdate();
  }

  addResources(manager) {
    // Add images for the stamp, point, hot spot, and lock annotations
    manager.resources = LeadtoolsResourceHelper.getResources();
  }

  onFill() {
    // check if an object is currently "selected"
    const currentEditObject: lt.Annotations.Engine.AnnObject = this.automation.currentEditObject;
    if (currentEditObject != null) {
      // check if this object supports a stroke
      if (currentEditObject.supportsFill) {
        // change its fill
        this.automation.beginUndo();

        currentEditObject.fill = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawDefaults.fillColor);

        this.automation.endUndo();
        this.automation.invalidate(lt.LeadRectD.get_empty());
      } else {
        // alert("This object does not support stroke, select another object");
      }
    } else {
      alert('Select an object first');
    }
  }

  findAnnObj(objId) {
    const obj: lt.Annotations.Automation.AnnAutomationObject = this.manager.findObjectById(objId);
    const annObjTemplate = obj.objectTemplate;
    if (annObjTemplate.supportsFill) {
      this.changeFillRegionColor(annObjTemplate);
    }
  }

  changeFillRegionColor(annObjTemplate) {
    const fillColor = new lt.Annotations.Engine.AnnSolidColorBrush();
    fillColor.color = this.currentAnnotationDefaults.fillColor;

    annObjTemplate.fill = fillColor;
    // this.imageViewer.invalidate(lt.LeadRectD.empty);
    this.automation.invalidate(lt.LeadRectD.empty);
  }

  changeLineSizeColor(width, color) {
    const automationObjCount = this.manager.objects.count;
    for (let i = 0; i < automationObjCount; i++) {
      // Get the object
      const automationObj = this.manager.objects.item(i);
      const annObjectTemplate = automationObj.objectTemplate;

      if (annObjectTemplate != null) {
        if (!(annObjectTemplate instanceof lt.Annotations.Engine.AnnTextObject)) {
          if (annObjectTemplate.supportsStroke) {
            const stroke = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create(color),
              lt.LeadLengthD.create(width));
            stroke.strokeEndLineCap = lt.Annotations.Engine.AnnStrokeLineCap.flat;
            stroke.strokeStartLineCap = lt.Annotations.Engine.AnnStrokeLineCap.flat;

            annObjectTemplate.stroke = stroke;
            this.automation.invalidateObject(annObjectTemplate);
            this.onAnnotationChange(this.manager.currentObjectId);
          }
        }
      }
    }
    // this.setSelectedAnnotationStrokeRed();
  }

  changeTextColor(color) {
    const automationObjCount = this.manager.objects.count;
    for (let i = 0; i < automationObjCount; i++) {
      // Get the object
      const automationObj = this.manager.objects.item(i);
      const annObjectTemplate = automationObj.objectTemplate;

      if (annObjectTemplate != null) {
        if (annObjectTemplate instanceof lt.Annotations.Engine.AnnTextObject || annObjectTemplate instanceof lt.Annotations.Engine.AnnTextPointerObject) {
            const textColor = lt.Annotations.Engine.AnnSolidColorBrush.create(color);

            annObjectTemplate.textForeground = textColor;
            this.automation.invalidateObject(annObjectTemplate);
            this.onAnnotationChange(this.manager.currentObjectId);
        }
      }
    }
  }

  private setSelectedAnnotationStrokeRed(): void {
    // console.log('setSelectedAnnotationStrokeRed');
    const selected = this.automation?.currentEditObject;
    if (!selected) return;

    // Prefer stroke color change for any object that supports stroke
    if (selected.supportsStroke) {
      const existingStroke = selected.stroke;
      const thickness = existingStroke?.strokeThickness?.value ?? this.currentDrawDefaults?.strokeWidth ?? 2;

      const redStroke = lt.Annotations.Engine.AnnStroke.create(
        lt.Annotations.Engine.AnnSolidColorBrush.create('#FF0000'),
        lt.LeadLengthD.create(thickness)
      );
      // Preserve existing caps if available
      if (existingStroke) {
        redStroke.strokeStartLineCap = existingStroke.strokeStartLineCap;
        redStroke.strokeEndLineCap = existingStroke.strokeEndLineCap;
      }
      selected.stroke = redStroke;
      this.automation.invalidateObject(selected);
      return;
    }

    // As a fallback for objects without stroke, try text foreground
    if (selected instanceof lt.Annotations.Engine.AnnTextObject) {
      selected.textForeground = lt.Annotations.Engine.AnnSolidColorBrush.create('#FF0000');
      this.automation.invalidateObject(selected);
    }
  }

  private automation_EditText(sender: any, e: lt.Annotations.Engine.AnnEditTextEventArgs): void {
    const automation = this.automation;
    if (automation == null) {
      return;
    }

    this.removeAutomationTextArea(true);

    if (e.textObject == null) {
      return;
    }
    e.textObject.font.fontSize = 12;

    const imageViewer = this.imageViewer;
    // this.automationTextArea = new lt.Demos.Annotations.AutomationTextArea(imageViewer.mainDiv.parentNode as HTMLDivElement, automation, e, (update: boolean) => this.removeAutomationTextArea(update));
    this.automationTextArea = new lt.Demos.Annotations.AutomationTextArea(imageViewer.mainDiv.parentNode as HTMLDivElement, automation, e, (update: boolean) => {
      const origFontSize = this.currentDrawTextDefaults.fontSizeTxt;
      // console.log('origFontSize ', origFontSize);
      // console.log('scaleFactor ', this.imageViewer.scaleFactor); // this.imageViewer.scaleFactor = .435
      const pointToScreen = 72.0 / 96;
      const fontSize = origFontSize / this.imageViewer.scaleFactor / 1;
      const newFontSizeTmp1 = fontSize + (pointToScreen / 2);
      let newFontSize: number;
      if (newFontSizeTmp1 > 1) {
        newFontSize = newFontSizeTmp1;
      } else {
        newFontSize = 1;
      }
      // console.log('newFontSize ', newFontSize);
      // console.log('textsize ', e.textObject.textSize);
      // console.log('width ', e.bounds.width);
      // e.textObject.font.fontSize = 12;
      e.textObject.font.fontSize = newFontSize;


      this.removeAutomationTextArea(update);
    });
    // TX-6554: highlight the placeholder text (e.g. 'Example Text') so the doctor can
    // overwrite it immediately instead of manually selecting and deleting it first.
    this.selectAutomationTextAreaContents();
e.cancel = true;
  }

  /**
   * Selects (highlights) the contents of the inline annotation text editor's
   * textarea. The LEADTOOLS AutomationTextArea only focuses the textarea after it
   * is created, leaving the default placeholder text un-highlighted with the caret
   * inside it. Selecting the contents lets the doctor start typing over it right
   * away. (TX-6554)
   */
  private selectAutomationTextAreaContents(): void {
    const automationTextArea = this.automationTextArea as any;
    const textArea: HTMLTextAreaElement = automationTextArea && automationTextArea._textAreaElement;
    if (textArea && typeof textArea.select === 'function') {
      textArea.select();
    }
  }

  private removeAutomationTextArea(update: boolean): void {
    if (this.automationTextArea == null) {
      return;
    }

    this.automationTextArea.remove(update);
    this.automationTextArea = null;
  }

  imageViewerSizeChanged() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.repaintWhenReady();
      }, 10);
    });
  }

  onObjectChange(event) {
    const id = parseInt(event.target.options[event.target.selectedIndex].value);
    // console.log('TdoImagingImageContainerComponent Selected in event: ' + id);
    // Set it as the current object in the manager
    this.manager.currentObjectId = id;
  }

  onAnnotationChangeWorking(id) {
    this.imageViewer.interactiveModes.beginUpdate();
    for (let i = 0; i < this.imageViewer.interactiveModes.count; i++) {
      this.imageViewer.interactiveModes.item(i).isEnabled = false;
    }
    if (id === 0) {
      this.panZoomInteractiveMode.isEnabled = true;
    }
    else {
      this.automationInteractiveMode.isEnabled = true;
      this.contextInteractiveMode.isEnabled = true;
      this.manager.currentObjectId = id;
    }
    this.imageViewer.interactiveModes.endUpdate();
    // this.updateAnnotationsObjectsBtnsCheckedState();
  }

  onAnnotationChange(id) {
    this.isRotation = false;
    this.imageViewer.interactiveModes.beginUpdate();
    for (let i = 0; i < this.imageViewer.interactiveModes.count; i++) {
      this.imageViewer.interactiveModes.item(i).isEnabled = false;
    }
    this.automationInteractiveMode.isEnabled = true;
    this.contextInteractiveMode.isEnabled = true;
    this.manager.currentObjectId = id;
    if (!this.isCalibrationInfoAvailable) {
      this.noCalibrationFound();
    }
    this.imageViewer.interactiveModes.endUpdate();
  }

  async onAddStamp() {
    let toothText: string = '';
    let i: number = 0;
    let stampText: string = '';
    let maxRowLength: string = '';
    let rowLength: string = '';
    let rowNumber: number = 0;
    if (this.toothDetailList) {
      for (const item of this.toothDetailList) {
        if (i > 0) {
          toothText += ',';
        }
        toothText += item.Notation;
        i++;
      }
    }
    const labelsRes = await this.labelService.getLabelTokensByFormattedLabel(
      FormattedLabelEnum.ImageStamp,
      this.globals.currentPatientId,
      null,
      this.document.DocumentID
    ).toPromise();

    if (labelsRes) {
      var labels = labelsRes;
      rowNumber = labels.length;
      for (let label of labels) {
        if (label.isEndOfLine) {
          rowLength += `${label.Prefix} ${label.value} ${label.Sufix}\n`;
          stampText += `${label.Prefix} ${label.value} ${label.Sufix}\n`;
          if (rowLength.length > maxRowLength.length) {
            maxRowLength = rowLength;
          }
          rowLength = '';
        } else {
          rowLength += `${label.Prefix} ${label.value} ${label.Sufix}`;
          stampText += `${label.Prefix} ${label.value} ${label.Sufix}`;
          if (rowLength.length > maxRowLength.length) {
            maxRowLength = rowLength;
          }
        }
      }
    }
    const automationObject = this.manager.findObjectById(AnnObject.textObjectId);
    const stampObject = automationObject.objectTemplate.clone();
    let fontSizeD;
    if (stampObject instanceof lt.Annotations.Engine.AnnTextObject) {
      this.imageViewer.interactiveModes.beginUpdate();
      for (let i = 0; i < this.imageViewer.interactiveModes.count; i++) {
        this.imageViewer.interactiveModes.item(i).isEnabled = false;
      }
      this.automationInteractiveMode.isEnabled = true;
      this.contextInteractiveMode.isEnabled = true;
      const scaleFactor = this.imageViewer.get_scaleFactor();
      const container = this.automation.activeContainer;
      const mapper = container.mapper.clone();
      mapper.updateTransform(LeadMatrix.identity);
      mapper.fontRelativeToDevice = false;
/*
      stampObject.fill = null;
      stampObject.textBackground = null;
*/
      stampObject.text = stampText;
      stampObject.textForeground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawStampDefaults.foregroundStdStamp);
/*
      if (this.currentDrawStampDefaults.backgroundStdStamp !== 'Transparent' &&
        this.currentDrawStampDefaults.backgroundStdStamp !== '#ffffff') {
        stampObject.textBackground = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawStampDefaults.backgroundStdStamp);
      }
*/

      if (this.currentDrawStampDefaults.backgroundStdStamp !== 'Transparent' ) {
        stampObject.fill = lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawStampDefaults.backgroundStdStamp);
      }
      if (!this.currentDrawStampDefaults.fontNameStdStamp || !this.currentDrawStampDefaults.fontSizeStdStamp) {
        // Use default font if settings are invalid
        stampObject.font = new lt.Annotations.Engine.AnnFont("Arial", 12);
      } else {
        stampObject.font = new lt.Annotations.Engine.AnnFont(
          this.currentDrawStampDefaults.fontNameStdStamp,
          this.currentDrawStampDefaults.fontSizeStdStamp
        );
      }

/*
      if (!this.leadToolsHelper.enumFonts || !this.currentDrawStampDefaults.fontStdStamp ||
          !this.leadToolsHelper.enumFonts[this.currentDrawStampDefaults.fontStdStamp]) {
        // Use default font if settings are invalid
        stampObject.font = new lt.Annotations.Engine.AnnFont("Arial", 12);
      } else {
        stampObject.font = new lt.Annotations.Engine.AnnFont(
          this.leadToolsHelper.enumFonts[this.currentDrawStampDefaults.fontStdStamp].name,
          this.currentDrawStampDefaults.fontSizeStdStamp || 12
        );
      }
*/

      // annObjectTemplate.font.fontStyle = this.fontStyles[this.currentDrawTextDefaults.fontStyleTxt];
      //stampObject.font = new lt.Annotations.Engine.AnnFont("Arial", 12);
      switch (this.currentDrawStampDefaults.fontStyleStdStamp.toString()) {
        case this.leadToolsHelper.enumFontStyles[0].value.toString():
          stampObject.font.fontStyle = 0;
          break;
        case this.leadToolsHelper.enumFontStyles[1].value.toString():
          stampObject.font.fontWeight = lt.Annotations.Engine.AnnFontWeight.bold;
          break;
        case this.leadToolsHelper.enumFontStyles[2].value.toString():
          stampObject.font.fontStyle = 1;
          break;
        case this.leadToolsHelper.enumFontStyles[3].value.toString():
          stampObject.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.underline;
          break;
        case this.leadToolsHelper.enumFontStyles[4].value.toString():
          stampObject.font.textDecoration = lt.Annotations.Engine.AnnTextDecorations.strikethrough;
          break;
      }
      const strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create('Transparent'),
        lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxt));
/*
      const strokeTxt = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create(this.currentDrawTextDefaults.borderColorTxt),
        lt.LeadLengthD.create(this.currentDrawTextDefaults.lineWidthTxt));
*/
      stampObject.stroke = strokeTxt;
      const origFontSize = stampObject.font.fontSize;
      const pointToScreen = 72.0 / 96;
      const fontSize = origFontSize / this.imageViewer.scaleFactor / 1;
      const newFontSizeTmp1 = fontSize + (pointToScreen / 2);
      let newFontSize: number;
      if (newFontSizeTmp1 > 1) {
        newFontSize = newFontSizeTmp1;
      } else {
        newFontSize = 1;
      }
      stampObject.font.fontSize = newFontSize;

      fontSizeD = new LeadSizeD();
      /*this.annRenderingEngine = new lt.Annotations.Engine.AnnRenderingEngine();
      fontSizeD = this.annRenderingEngine.measureString(stampText, stampObject.font);*/
      const annRenderingEngine = new lt.Annotations.Rendering.AnnHtml5RenderingEngine();
      fontSizeD = annRenderingEngine.measureString(maxRowLength, stampObject.font);
      fontSizeD.height = fontSizeD.height * rowNumber;
      const imageRect = new LeadRectD();
      imageRect.x = 0;
      imageRect.y = 0;
      imageRect.size = this.imageViewer.imageSize;

      // fontSizeD.height = 150;
      // fontSizeD.width = 500;
      let viewRect = this.getStampRect(imageRect, fontSizeD);
      // const viewRect = new LeadRectD();
      viewRect = mapper.rectToContainerCoordinates(viewRect);
      const upperLeft = viewRect.topLeft;
      stampObject.points.add(upperLeft);
      const upperRight = viewRect.topRight;
      stampObject.points.add(upperRight);
      const lowerRight = viewRect.bottomRight;
      stampObject.points.add(lowerRight);
      const lowerLeft = viewRect.bottomLeft;
      stampObject.points.add(lowerLeft);
      this.automation.container.children.add(stampObject);
      this.imageViewer.interactiveModes.endUpdate();
      this.imageViewer.invalidate(lt.LeadRectD.empty);
    }

  }
  getStampRect(imageRect: LeadRectD, stampSize: LeadSizeD) {
    let location: LeadPointD = LeadPointD.empty;
    switch (this.currentDrawStampDefaults.locationStdStamp.toString()) {
      case this.leadToolsHelper.enumStampLocations[1].value.toString():
        location = new LeadPointD();
        location.x = 0;
        location.y = 0;
        break;
      case this.leadToolsHelper.enumStampLocations[2].value.toString():
        location = new LeadPointD();
        location.x = (imageRect.width - stampSize.width) + imageRect.left;
        location.y = imageRect.top;
        break;
      case this.leadToolsHelper.enumStampLocations[3].value.toString():
        location = new LeadPointD();
        location.x = imageRect.left;
        location.y = (imageRect.height - stampSize.height) + imageRect.top;
        break;
      case this.leadToolsHelper.enumStampLocations[4].value.toString():
        location = new LeadPointD();
        location.x = (imageRect.width - stampSize.width) + imageRect.left;
        location.y = (imageRect.height - stampSize.height) + imageRect.top;
        break;
    }
    const stampLoc = new LeadRectD();
    stampLoc.x = location.x;
    stampLoc.y = location.y;
    stampLoc.size = stampSize;
    return stampLoc;
  }

  disableInteractiveModes() {
    this.imageViewer.interactiveModes.beginUpdate();
    // turn off all interactivemodes
    // this.imageViewer.interactiveModes.enableById(lt.Controls.ImageViewerInteractiveMode.panZoomModeId);
    const panZoom: lt.Controls.ImageViewerInteractiveMode = this.imageViewer.interactiveModes.findById(lt.Controls.ImageViewerInteractiveMode.panZoomModeId);
    panZoom.isEnabled = false;

    const magnify: lt.Controls.ImageViewerInteractiveMode = this.imageViewer.interactiveModes.findById(lt.Controls.ImageViewerInteractiveMode.magnifyGlassModeId);
    magnify.isEnabled = false;

    const zoomSelect: lt.Controls.ImageViewerInteractiveMode = this.imageViewer.interactiveModes.findById(lt.Controls.ImageViewerInteractiveMode.zoomToModeId);
    zoomSelect.isEnabled = false;

    const zoomDrag: lt.Controls.ImageViewerInteractiveMode = this.imageViewer.interactiveModes.findById(lt.Controls.ImageViewerInteractiveMode.zoomAtModeId);
    zoomDrag.isEnabled = false;

    const spyGlass: lt.Controls.ImageViewerInteractiveMode = this.imageViewer.interactiveModes.findById(lt.Controls.ImageViewerInteractiveMode.spyGlassModeId);
    spyGlass.isEnabled = false;

    this.imageViewer.interactiveModes.endUpdate();
  }

  onFillRegion() {
    this.manager.userMode = lt.Annotations.Engine.AnnUserMode.run;
  }

  autoSaveImage(callback) {
    // console.log("TdoImagingImageContainerComponent autosave start");

    this.docClassId = DocumentClassEnum.Original;
    if (this.automation.container.children.count > 0) {
      this.hasAnnotation = true;
    }

    let canvas = this.imageViewer.canvas;

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = this.imageViewer.imageUrl;

    // document.body.append(image);
    image.onload = () => {
      // Check if the viewer has a canvas
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d').drawImage(image, 0, 0);
      }
      this.enumDocumentFileTypeIdJPG = DocumentFileTypeEnum.JPG;
      this.blob = canvas.toDataURL('image/jpeg');

      // thumbnail stuff
      this.createThumbnail();


    };
    // document.body.removeChild(image);
    setTimeout(() => {
      callback();
    }, 200);
  }

  getImageViewerBlob(saveAnnFile, bBurnAnn, bsavelocal, callback) {
    this.isSaving = true;
    if (this.automation.container.children.count > 0) {
      this.hasAnnotation = true;
    }

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = this.imageViewer.imageUrl;

    if (bsavelocal) {
      image.onload = () => {
        let canvas = this.imageViewer.canvas;
        if (!canvas) {
          canvas = document.createElement('canvas');
          canvas.width = image.width;
          canvas.height = image.height;
          canvas.getContext('2d').drawImage(image, 0, 0);
        }
        this.enumDocumentFileTypeIdJPG = DocumentFileTypeEnum.JPG;

        this.blob = canvas.toDataURL('image/jpeg');
        document.body.append(image);
        const a = document.createElement('a');
        a.href = this.blob;
        // a.download = "output.png";
        a.download = 'output.jpg';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        if (bBurnAnn) {
          this.docClassId = DocumentClassEnum.StdBurnedIn;
        } // <-burned in annotation
        else {
          this.docClassId = DocumentClassEnum.Original;
        } // <-original source

        this.file = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
        // save annotation file
        if (saveAnnFile) {
          // this.docClassId = this.enumDocumentClasTypeIdAnn; //<-burned in annotation
          // Create the codecs object to save and load annotations
          this.codecs = new lt.Annotations.Engine.AnnCodecs();
          // Save the container
          this.xmlData = this.codecs.save(this.automation.container, lt.Annotations.Engine.AnnFormat.annotations, null, 1);

          // var content = '<a id="a"><b id="b">hey!</b></a>'; // the body of the new file...
          this.xmlfile = new Blob([this.xmlData], { type: 'text/xml' });

          // thumbnail stuff
          this.createThumbnail();
        }
      };
    } else {
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d').drawImage(image, 0, 0);
        this.enumDocumentFileTypeIdJPG = DocumentFileTypeEnum.JPG;

        this.blob = canvas.toDataURL('image/jpeg');

        if (bBurnAnn) {
          this.docClassId = DocumentClassEnum.StdBurnedIn;
        } // <-burned in annotation
        else {
          this.docClassId = DocumentClassEnum.Original;
        } // <-original source

        this.file = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
        // save annotation file
        if (saveAnnFile) {
          // this.docClassId = this.enumDocumentClasTypeIdAnn; //<-burned in annotation
          // Create the codecs object to save and load annotations
          this.codecs = new lt.Annotations.Engine.AnnCodecs();
          // Save the container
          this.xmlData = this.codecs.save(this.automation.container, lt.Annotations.Engine.AnnFormat.annotations, null, 1);

          // var content = '<a id="a"><b id="b">hey!</b></a>'; // the body of the new file...
          this.xmlfile = new Blob([this.xmlData], { type: 'text/xml' });

          // thumbnail stuff
          this.createThumbnail();
        }
      };
    }
    // document.body.removeChild(image);
    setTimeout(() => {
      // console.log("After 200 milliseconds call a callback-function.");
      // after 200 milliseconds
      // calling a callback function
      callback();
    }, 200);
  }

  imageViewerGetBlob4BlankImage(callback) {
    // Create canvas element and set desired height and width
    let canvas = document.createElement('canvas');
    canvas.width = this.currentDrawCanvasDefaults.width;
    canvas.height = this.currentDrawCanvasDefaults.height;
    // Get the 2D rendering context of the canvas
    const ctx = canvas.getContext('2d');
    let imageData;

    if (this.xImage.imageSource.includes('Gradient')) {
      const grd = ctx.createLinearGradient(0, 0, 200, 0);
      grd.addColorStop(0, this.currentDrawCanvasDefaults.startColor);
      grd.addColorStop(1, this.currentDrawCanvasDefaults.endColor);

      // Fill with gradient
      ctx.fillStyle = grd;
      ctx.fillRect(0, 0, 600, 600);
      // Create blank image data
      imageData = ctx.createImageData(canvas.width, canvas.height - 590);
    }
    else {
      // Create blank image data
      imageData = ctx.createImageData(canvas.width, canvas.height);
    }
    let canvasColor = 0;
    if (this.xImage.imageSource.includes('White')) {
      canvasColor = 255;
    }
    // Set all pixels to white

    for (let i = 0; i < imageData.data.length; i += 4) {
      imageData.data[i] = canvasColor; // Red channel
      imageData.data[i + 1] = canvasColor; // Green channel
      imageData.data[i + 2] = canvasColor; // Blue channel
      imageData.data[i + 3] = canvasColor; // Alpha channel (opacity), if you want true blank, this is what needs to be set
    }

    // Put the image data onto the canvas
    ctx.putImageData(imageData, 0, 0);

    // Get the data URL of the canvas content
    const dataURL = canvas.toDataURL();

    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = dataURL;
    this.imageViewer.imageUrl = dataURL;
    document.body.append(image);
    image.onload = () => {
      this.originalImage = image;
      // Check if the viewer has a canvas
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d').drawImage(image, 0, 0);
      }
      this.blob = canvas.toDataURL('image/jpeg');
      // this.uploadImage.emit(ImageUtilities.base64ToBlob(this.blob, 'image/jpeg'));
      // Create the codecs object to save and load annotations
      // console.log("TdoImagingImageContainerComponent this.automation.container", this.automation.container);


      this.codecs = new lt.Annotations.Engine.AnnCodecs();
      // Save the container
      this.xmlData = this.codecs.save(this.automation.container, lt.Annotations.Engine.AnnFormat.annotations, null, 1);
    };


    document.body.removeChild(image);

    setTimeout(() => {
      // after 100 milliseconds
      // calling a callback function

      callback();
    }, 100);
  }


  imageViewerGetBlob(callback) {
    let canvas = this.imageViewer.canvas;
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = this.imageViewer.imageUrl;
    let callbackFired = false;
    //Claude
    const fireCallback = () => {
      if (callbackFired) return;
      callbackFired = true;
      if (document.body.contains(image)) {
        document.body.removeChild(image);
      }
      callback();
    };

    document.body.append(image);
    image.onload = () => {
      this.originalImage = image;
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d').drawImage(image, 0, 0);
      }
      this.blob = canvas.toDataURL('image/jpeg');
      this.codecs = new lt.Annotations.Engine.AnnCodecs();
      this.xmlData = this.codecs.save(this.automation.container, lt.Annotations.Engine.AnnFormat.annotations, null, 1);
      fireCallback();
    };
    image.onerror = fireCallback;
    // 2000ms gives time for onload to fire even on first-login uncached network images.
    // For cached images onload fires in <1ms so this timeout is never reached.
    setTimeout(fireCallback, 2000);
  }

  burnAnnotations() {
    const imageCanvas: HTMLCanvasElement = this.imageViewer.activeItem.canvas;
    const context = imageCanvas.getContext('2d');

    const renderingEngine: lt.Annotations.Rendering.AnnHtml5RenderingEngine = new lt.Annotations.Rendering.AnnHtml5RenderingEngine();
    renderingEngine.resources = this.manager.resources;
    renderingEngine.renderers = this.renderingEngine.renderers;
    renderingEngine.attach(this.automation.container, context);

    if (renderingEngine) {
      const imageRes = this.imageViewer.imageResolution;
      // renderingEngine.burn();
      renderingEngine.burnToRectWithDpi(lt.LeadRectD.empty, imageRes.width, imageRes.height, imageRes.width, imageRes.height);
      // const dpiX: number = this.imageViewer.screenDpi.width;
      // const dpiY: number = this.imageViewer.screenDpi.height;
      // const xRes: number = this.imageViewer.activeItem.resolution.width;
      // const yRes: number = this.imageViewer.activeItem.resolution.height;
      // renderingEngine.burnToRectWithDpi(lt.LeadRectD.empty, dpiX, dpiY, xRes, yRes);
    }

    const automationControl = this.automation.automationControl;
    automationControl.automationInvalidate(lt.LeadRectD.empty);
  }

  onValueChanged(e) {
    // console.log("onValueChanged 1", e.value.length);
    if (e.value.length > 0) {
      this.categories = e.value.map(vv => {
        return (vv.ValidValueItemId);
      });
      // console.log('onValueChanged categories', this.categories);
      this.imageCategoryIds = e.value;
      this.imageCategoriesChange.emit(this.imageCategoryIds);
    }
  }

  onZoom1x() {
    this.imageViewer.zoom(
      lt.Controls.ControlSizeMode.fit,
      1.0,
      this.imageViewer.defaultZoomOrigin
    );
  }

  onZoom2x() {
    this.imageViewer.zoom(
      lt.Controls.ControlSizeMode.fit,
      2.0,
      this.imageViewer.defaultZoomOrigin
    );
  }

  onFitToPage() {
    this.imageViewer.zoom(
      lt.Controls.ControlSizeMode.fit,
      0.9,
      this.imageViewer.defaultZoomOrigin
    );
  }
  invert() {
    const jsMainFilePath = this.jsImgColorFilePath;
    this.imageProcessingLeadtools('Invert', jsMainFilePath);
  }
  grayScale() {
    const jsMainFilePath = this.jsImgColorFilePath;
    this.imageProcessingLeadtools('Grayscale', jsMainFilePath);
  }

  flip(angle) {
    this.rotate = true;
    this.bCrop = false;
    this.thumbnail = false;
    this.angle = angle;
    const jsMainFilePath = 'assets/leadtools/Leadtools.ImageProcessing.Main.js';
    switch (angle) {
      case 0:
        this.imageProcessingLeadtools('Flip', jsMainFilePath);
        break;
      case 90:
        // this.imageProcessingLeadtools('Rotate', jsMainFilePath);
        this.imageViewerGetBlob(() => {
          const intervalSubscription = setInterval(_ => {
            this.imgblob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
            // this.imageViewer.imageUrl = URL.createObjectURL(this.imgblob);
            if (this.imgblob != null) {
              clearInterval(intervalSubscription);
              this.uploadBlob(this.imgblob);
            }
          }, 100);
        });
        break;
      case 180:
        this.imageProcessingLeadtools('Reverse', jsMainFilePath);
        break;
      case 1:
        this.angle = 180;
        this.imageProcessingLeadtools('Flip', jsMainFilePath, null, true);
        break;
    }
  }

  crop() {
    this.bCrop = true;
    this.thumbnail = false;
    this.rotate = false;
    this.automationInteractiveMode.idleCursor = 'move';
    this.automationInteractiveMode.workingCursor = 'crosshair';
    this.imageViewerGetBlob(() => {
      const intervalSubscription = setInterval(_ => {
        this.imgblob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
        this._ownedObjectUrl.assignToViewer(this.imgblob, this.imageViewer);
        if (this.imgblob != null) {
          clearInterval(intervalSubscription);
          this.imageViewer.interactiveModes.beginUpdate();
          for (let i = 0; i < this.imageViewer.interactiveModes.count; i++) {
            this.imageViewer.interactiveModes.item(i).isEnabled = false;
          }
          this.rubberBandMode.isEnabled = true;
          this.imageViewer.interactiveModes.endUpdate();
        }
      }, 100);
    });
  }

  createThumbnail() {
    this.thumbnail = true;
    this.bCrop = false;
    this.rotate = false;

    this.imageViewerGetBlob(() => {
      const intervalSubscription = setInterval(_ => {
        this.imgblob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
        // this.imageViewer.imageUrl = URL.createObjectURL(this.imgblob);
        if (this.imgblob != null) {
          clearInterval(intervalSubscription);
          this.uploadBlob(this.imgblob);
        }
      }, 100);
    });

  }

  stopRotation() {
    this.rotate = true;
    this.thumbnail = false;
    this.bCrop = false;
    this.angle = this.imageViewer.rotateAngle;

    this.imageViewerGetBlob(() => {
      const intervalSubscription = setInterval(_ => {
        this.imgblob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
        // this.imageViewer.imageUrl = URL.createObjectURL(this.imgblob);
        if (this.imgblob != null) {
          clearInterval(intervalSubscription);
          this.uploadBlob(this.imgblob);
        }
      }, 100);
    });

  }

  resetRotation() {
    this.imageViewer.rotateAngle = 0;
  }

  cancelRotation() {
    this.resetRotation();
    this.cancelInteractiveModes();
  }

  cancelInteractiveModes() {
    this.imageViewer.interactiveModes.beginUpdate();
    for (let i = 0; i < this.imageViewer.interactiveModes.count; i++) {
      this.imageViewer.interactiveModes.item(i).isEnabled = false;
    }
    this.imageViewer.interactiveModes.endUpdate();
  }

  onMagnification(mode) {
    this.imageViewer.interactiveModes.beginUpdate();
    for (let i = 0; i < this.imageViewer.interactiveModes.count; i++) {
      this.imageViewer.interactiveModes.item(i).isEnabled = false;
    }

    if (mode === 0) {
      this.panZoomInteractiveMode.isEnabled = true;
      this.panZoomInteractiveMode.enablePan = false;
      this.panZoomInteractiveMode.enableZoom = true;
      this.panZoomInteractiveMode.zoomKeyModifier = Keys.none;
    }
    else if (mode === 1) {
      this.magnifyInteractiveMode.isEnabled = true;
    }
    else if (mode === 2) {
      this.zoomToInteractiveMode.isEnabled = true;
    }
    else if (mode === 3) {
      this.spyGlassInteractiveMode.isEnabled = true;
    }
    else if (mode === 4) {
      this.rotateInteractiveMode.isEnabled = true;
      this.isRotation = true;
    }
    else if (mode === 5) {
      this.imgProcessingInteractiveMode.isEnabled = true;
    }
    else if (mode === 6) {
      this.imgProcessingInteractiveMode.isEnabled = false;
    }
    this.imageViewer.interactiveModes.endUpdate();
  }

  xProcessImage(command: string, imageUrl: string, model: TDOxImage) {
    const ipComplete = (sender: any, e: lt.ImageProcessingCompletedEventArgs) => {
      sender.abort();
      if (e.imageData) {
        const ctx: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
        const imageData = e.imageData;
        // After applying image processing on a temp canvas,  we need to put the image data back onto the dialog canvas
        ctx.putImageData(imageData, 0, 0);
        this.imageViewer.invalidate(lt.LeadRectD.empty);
      }
    };
    // If we are running, abort the previous before starting a new one
    if (Globals.imageProcessingInstance != null && Globals.imageProcessingInstance.isRunning) {
      Globals.imageProcessingInstance.abort();
    }
    const tempCanvas: HTMLCanvasElement = document.createElement('canvas');
    const image = new Image();
    image.crossOrigin = 'anonymous';
    if (this.imageViewer.imageUrl != null) {
      image.src = this.imageViewer.imageUrl;
    }
    else {
      image.src = imageUrl;
    }
    image.onload = () => {
      tempCanvas.width = image.width;
      tempCanvas.height = image.height;
      tempCanvas.getContext('2d').drawImage(image, 0, 0);

      // Get the source canvas image data
      const context: CanvasRenderingContext2D = tempCanvas.getContext('2d');
      const imageProcessing: lt.ImageProcessing = new lt.ImageProcessing();
      imageProcessing.jsFilePath = this.jsImgColorFilePath;
      imageProcessing.command = command;

      // const imgData: ImageData = context.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
      imageProcessing.imageData = context.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
      switch (command) {
        case ProcessingCommandsEnum.ContrastBrightnessIntensity:
          imageProcessing.arguments['contrast'] = model.contrastVal;
          imageProcessing.arguments['brightness'] = model.brightnessVal;
          imageProcessing.arguments['intensity'] = 0;
          break;
        case ProcessingCommandsEnum.GammaCorrect:
          imageProcessing.arguments['gamma'] = model.gammaVal;
          break;
        case ProcessingCommandsEnum.Sharpen:
          imageProcessing.jsFilePath = this.jsImgEffectsFilePath;
          imageProcessing.arguments['sharpness'] = model.brightnessVal;
          break;
      }

      imageProcessing.completed.add(ipComplete);

      if (!imageProcessing.imageData) {
        console.warn('xProcessImage: imageData is null, skipping processing');
        return;
      }
      imageProcessing.run();
      Globals.imageProcessingInstance = imageProcessing;
    };
  }

  imgContrast(contrastVal, imageUrl) {
    const model = new TDOxImage();
    model.brightnessVal = this.xImage.brightnessVal;
    model.contrastVal = contrastVal;
    this.xProcessImage(ProcessingCommandsEnum.ContrastBrightnessIntensity, imageUrl, model);
    this.xImage.contrastVal = contrastVal;
  }

  imgBrightness(brightnessVal, imageUrl) {
    const model = new TDOxImage();
    model.brightnessVal = brightnessVal;
    model.contrastVal = this.xImage.contrastVal;
    this.xProcessImage(ProcessingCommandsEnum.ContrastBrightnessIntensity, imageUrl, model);
    this.xImage.brightnessVal = brightnessVal;
  }

  imgGamma(gammaVal, imageUrl) {
    const model = new TDOxImage();
    model.gammaVal = gammaVal;
    this.xProcessImage(ProcessingCommandsEnum.GammaCorrect, imageUrl, model);
    this.xImage.gammaVal = gammaVal;
  }

  // Currently not used
  imgSharpness(sharpnessVal) {
    const myCanvas = this.imageViewer.canvas;
    const context = myCanvas.getContext('2d');
    const imageProcessing: ImageProcessing = new lt.ImageProcessing();
    imageProcessing.jsFilePath = this.jsImgColorFilePath;
    imageProcessing.command = 'Sharpen';
    imageProcessing.arguments['sharpness'] = sharpnessVal;
    imageProcessing.imageData = context.getImageData(0, 0, myCanvas.width, myCanvas.height);
    imageProcessing.completed.add((sender, e) => {
      context.putImageData(e.imageData, 0, 0);
      this.imageViewer.invalidate(lt.LeadRectD.empty);
    });
    if (!imageProcessing.imageData) {
      console.warn('imgSharpness: imageData is null, skipping processing');
      return;
    }
    imageProcessing.run();

    this.xImage.sharpnessVal = sharpnessVal;
  }

  ctrlKeyBtn_Click($event) {
    this.bCtrlKeyDown = true;
  }

  ctrlKeyBtnRelease_Click($event) {
    this.bCtrlKeyDown = false;
  }

  deleteAnnotationBtn_Click($event) {
    if (this.automation.canDeleteObjects) {
      this.automation.deleteSelectedObjects();
      // this.automation(false);
    }
  }

  private annotationsPropertiesBtn_Click($event) {

    if (this.automation.canShowProperties) {
      this.automation.showObjectProperties();
    }
  }

  // This retrieves the manipulated image from leadtools backend service. (rotate, crop, etc)
  loadDocumentFromBlob(url: string, downloadAfterLoad: boolean) {
    // console.log('loadDocumentFromBlob url called');
    // Add the image width and height, so the service resizes the values
    // This is only needed if this demo is running on a mobile or tablet devices
    const imageSize: lt.LeadSizeD = this.imageViewer.imageSize;

    const options = new lt.Document.LoadDocumentOptions();
    if (this.thumbnail) {
      const paramsThumbnail = {
        ActionName: 'THUMBNAIL'
      };
      options.name = JSON.stringify(paramsThumbnail);
    } else {
      if (this.bCrop) {
        const params = {
          ActionName: 'CROP',
          RectTop: Math.floor(this.rect.top),
          RectLeft: Math.floor(this.rect.left),
          RectRight: Math.floor(this.rect.right),
          RectBottom: Math.floor(this.rect.bottom),
        };
        options.name = JSON.stringify(params);
      } else {
        const paramsRotate = {
          ActionName: 'ROTATE',
          RotationAngle: Math.floor(this.angle),
        };
        options.name = JSON.stringify(paramsRotate);
      }
    }

    lt.Document.DocumentFactory.loadFromUri(url, options)
      .done(async (doc) => {
        this.imageCategoryIds = this.imageCategoryIds.filter(id => id != null).map(str => str.toUpperCase());
        if (this.thumbnail) {
          if (this.automation.container.children.count > 0) {
            this.hasAnnotation = true;
          }
          const uploadModel = new DocumentUploadModel();
          uploadModel.blobXml = this.xmlfile;
          uploadModel.blob = ImageUtilities.base64ToBlob(this.blob, 'image/jpeg');
          uploadModel.docClassId = this.docClassId;
          uploadModel.docFileTypeId = this.enumDocumentFileTypeIdJPG;
          uploadModel.docTagIds = this.imageCategoryIds;
          uploadModel.hasAnnotation = this.hasAnnotation;
          uploadModel.deviceId = this.xImage.deviceId;
          if (!this.xImage.imageSource.toLowerCase().includes('canvas') && !this.xImage.imageSource.toLowerCase().includes('twain')) {
            if (this.fileName) {
              uploadModel.createDate = this.datePipe.transform(new Date(this.fileName.lastModified), 'MMM dd, yyyy H:mm:ss');
            }
          }
          this.saveToTdoFileSystem(uploadModel);
          this.createdThumbnailUrl = doc.pages.item(0).getThumbnailImageUrl();
        } else {
          this.imageViewer.imageUrl = doc.pages.item(0).getImageUrl();
          // console.log('mtm getting rotated image');
          this.isSaving = false;
        }
      })
      .fail((jqXHR: JQueryXHR, statusText: string, errorThrown: string): void => {
        console.error('Error loading the document.', jqXHR, statusText, errorThrown);
        this.uiService.displayMessage('Error', 'Error loading document from blob');
        this.isSaving = false;
      });
  }

  // TODO: Cleanup messaging system
  saveToTdoFileSystem(uploadModel: DocumentUploadModel) {
    // console.log('saveToTdoFileSystem uploadModel called', uploadModel);
    uploadModel.folderId = this.xImage.folderId;
    uploadModel.docTypeId = DocumentTypeEnum.Scan;
    uploadModel.patientId = this.globals.currentPatientId;
    uploadModel.patientCaseId = this.globals.currentPatientCaseId;
    uploadModel.isSaveAsNew = this.isSaveAsNew;
    // Save rewrites the document on screen: naming it keeps the save on the same records and the
    // same stored files. Save As New must stay unattached to it, or the stored document would be
    // filed as a version of the one it was copied from instead of becoming its own.
    uploadModel.parentDocId = this.isSaveAsNew ? null : this.xImage.ParentDocumentId;
    uploadModel.thumbDocId = this.isSaveAsNew ? null : this.xImage.thumbDocId;
    uploadModel.currentDocumentId = this.isSaveAsNew
      ? null
      : (this.xImage.DocumentId ?? this.xImage.loadedDocument?.DocumentID);
    // Add createDate logic when not saving as new
    if (!this.isSaveAsNew && this.xImage.createDate) {
      uploadModel.createDate = this.datePipe.transform(this.xImage.createDate, 'MMM dd, yyyy H:mm:ss');
    }

    if (!this.xImage.selectedTeeth) {
      this.xImage.selectedTeeth = [];
    }
    uploadModel.caseWorkItemToothIds = this.xImage.selectedTeeth.map(p => p.CaseWorkItemToothId);
    if (this.toothDetailList != null) {
      if (Object.keys(this.toothDetailList).length === 0) {
        // console.log('No tooth');
      }
      else {
        uploadModel.caseWorkItemId = this.toothDetailList[0].CaseWorkItemId;
      }
    }

    if (this.globals.currentPatientCaseId === 'null' ||
      (this.imageCategoryIds.some(id => id.toUpperCase() === DOCUMENT_TAG.PatientPicture.toUpperCase()))) {
      this.fileService.getCaseIdFormsRepo(this.globals.currentPatientId).subscribe((res) => {
        if (res) {
          uploadModel.patientCaseId = res;
        }
      });
    }
    const insuranceDocumentIndex = uploadModel.docTagIds.findIndex(t=> t.toUpperCase() === DOCUMENT_TAG.InsuranceCheck.toUpperCase() || t.toUpperCase() === DOCUMENT_TAG.InsuranceEOB.toUpperCase());
    if ( insuranceDocumentIndex> -1) {
      const insDocTag = this.documentTagList.find(p => p.ValidValueItemId.toUpperCase() === uploadModel.docTagIds[insuranceDocumentIndex].toUpperCase() );
      uploadModel.description = insDocTag.ItemDisplayValue;
    }



    // first call save original image keep bsavelocal to false we don't want to save to local the first time
    this.fileService.uploadDocuments([uploadModel])
      .subscribe((response) => {
        // console.log('saveToTdoFileSystem response ', response);
        if (response.status && response.status.includes('Error')) {
          // The endpoint reports failures as HTTP 200 with an error in `status`, so the error
          // callback below never runs: clear the saving flag here or the viewer spinner never hides.
          this.isSaving = false;
          this.uiService.displayMessage("Error", response.status);
        } else {
          this.document = response.documents[0];
          this.xImage.loadedDocument = this.document;
          this.xImage.DocumentId = this.document.DocumentID;
          this.xImage.ParentDocumentId = this.document.ParentDocumentID;

          // Regular Save creates a new document row each time (see uploadModel.parentDocId/thumbDocId versioning
          // above), so re-link every saved version to the recall (or whatever launched this Studio session).
          if (this.xImage.documentGroupObjectId) {
            const groupModel = new DocumentGroupCreationModel();
            groupModel.ObjectId = this.xImage.documentGroupObjectId;
            groupModel.PatientId = this.globals.currentPatientId;
            groupModel.documentIds = [this.document.DocumentID];
            // The 100ms UPDATE_DOCUMENT/storage nudge below can beat this request, so nudge Landing again once
            // the link exists - otherwise the recall viewer refetches before the image is in its DocumentGroup.
            this.fileService.createDocumentGroup(groupModel).subscribe(() => this.notifyLandingWindowPrePostRefresh());
          }

          for (const tag of this.document.dataDocumentTags) {
            tag.enumDocumentTag = this.documentTagList.find(p => p.ValidValueItemId === tag.enumDocumentTagID);
          }

          // console.log('Internal document Id: ' + this.document.DocumentID);
          this.isSaving = false;
          this.imageSaved.emit(this);
          this.uiService.displayMessage("Success", "File saved successfully");
          // this.snackbar.open('File saved successfully', '', { duration: 6000, verticalPosition: 'top' });

          // send message UPDATE_PATIENT_PICTURE to refresh Landing Page
          if (this.document.dataDocumentTags.findIndex(p => p.enumDocumentTagID?.toUpperCase() === DOCUMENT_TAG.PatientPicture) > -1) {
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', { patientId: this.globals.currentPatientId });
            this.notifyLandingWindowPatientPicture();
          }
          // send message UPDATE_INSURANCE_DOCUMENTS to refresh doc list in insurance payment
          if (this.document.dataDocumentTags.findIndex(p => p.enumDocumentTagID?.toUpperCase() === DOCUMENT_TAG.InsuranceCheck || p.enumDocumentTagID?.toUpperCase() === DOCUMENT_TAG.InsuranceEOB) > -1) {
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, SignalrService.UPDATE_INSURANCE_DOCUMENTS, { patientId: this.globals.currentPatientId, uploadedDocumentId: this.document.DocumentID });
          }
          setTimeout(() => {
            const pid = { patientId: this.globals.currentPatientId };
            // Unicast ensures the client's MessageUser hub handler runs for this user (landing pre/post op listens there). Broadcast alone may not invoke MessageUser on all hosts / Angular 21 timing.
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, SignalrService.UPDATE_DOCUMENT, pid);
            this.signalrService.messageAllUsers(SignalrService.UPDATE_DOCUMENT, pid);
            // Studio runs in a separate browser window with its own SignalR connection — landing may never receive MessageUser. Same-origin localStorage fires `storage` in other windows only.
            this.notifyLandingWindowPrePostRefresh();
          }, 100);
        }
      }, 
      error => {
        console.error('Error uploading documents:', error);
        this.uiService.displayMessage('Error', 'Error uploading document');
        this.isSaving = false;
      });
  }

  /**
   * Studio is `window.open` (separate context). SignalR unicast may not hit the main/landing window. localStorage is
   * same-origin; the `storage` event is raised in *other* windows when this value changes, so landing can refetch pre/post op.
   */
  private notifyLandingWindowPrePostRefresh(): void {
    try {
      localStorage.setItem(
        MessagingConstants.LOCAL_STORAGE_PREPOST_LANDING_REFRESH,
        JSON.stringify({
          patientId: this.globals.currentPatientId,
          patientCaseId: this.globals.currentPatientCaseId,
          t: Date.now()
        })
      );
    } catch {
      // private mode / quota
    }
  }

  private notifyLandingWindowPatientPicture(): void {
    try {
      localStorage.setItem(
        MessagingConstants.LOCAL_STORAGE_PATIENT_PICTURE_REFRESH,
        JSON.stringify({ patientId: this.globals.currentPatientId, t: Date.now() })
      );
    } catch {
      // private mode / quota
    }
  }

  reloadOriginalBlob() {
    this.undoAnnotation(1);
    this._ownedObjectUrl.assignToViewer(this.origBlob, this.imageViewer);
    this.imageViewer.invalidate(lt.LeadRectD.empty);
    this.xImage.brightnessVal = 0;
    this.xImage.contrastVal = 0;
    this.xImage.gammaVal = 100;
    this.setGammaValue.emit(this.xImage.gammaVal);
  }

  uploadBlob(blob: Blob) {
    const uploadDocumentOptions = new lt.Document.UploadDocumentOptions();
    // If we have the total size of the document set it. This will help optimize the upload process on the service
    uploadDocumentOptions.documentDataLength = blob.size;
    lt.Document.DocumentFactory.beginUploadDocument(uploadDocumentOptions)
      .done((uploadUri) => {
        lt.Document.DocumentFactory.uploadDocumentBlob(uploadUri, blob)
          .done(() => {
            lt.Document.DocumentFactory.endUpload(uploadUri)
              .done(() => {
                // Load it and check
                this.loadDocumentFromBlob(uploadUri, true);
              })
              .fail((jqXHR: JQueryXHR, statusText: string, errorThrown: string): void => {
                console.error('Error loading the document.', jqXHR, statusText, errorThrown);
              });
          })
          .fail((jqXHR: JQueryXHR, statusText: string, errorThrown: string): void => {
            console.error('Error loading the document.', jqXHR, statusText, errorThrown);
          });

      })
      .fail((jqXHR: JQueryXHR, statusText: string, errorThrown: string): void => {
        console.error('Error loading the document.', jqXHR, statusText, errorThrown);
      });
  }

  undoAnnotation(all) {
    if (all === 0) {
      this.automation.undo();
    } else {
      this.automation.container.children.clear();
    }
    this.automation.invalidate(lt.LeadRectD.get_empty());
  }

  rotateComplete() {
    // console.log('rotateComplete');
  }

  // UI Events
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  onOpenInFull() {
    this.maximize.emit(this);
  }

  onClose() {
    this.close.emit(this.ImageName);
    /*
        this.dialogService.openConfirmDialog('Are you sure you want to close this image?').subscribe((isConfirmed) => {
          if (isConfirmed) {
            // console.log('closing ' + this.ImageName);
            this.close.emit(this.ImageName);
          }
        });
    */
  }

  onEditTagsClick() {
    this.editTags.emit(this.document);
  }

  onContainerClicked(event: MouseEvent) {
    this.selected.emit(this);
  }
  onStopRotation() {
    // set isSaving to true to display spinner
    this.isSaving = true;
    this.isRotation = false;
    this.rotateInteractiveMode.isEnabled = false;
    this.messagingService.sendComponentMessage(MessagingConstants.STUDIO_STOP_IMAGE_ROTATION, {});
    this.stopRotation();
  }

  deleteTag(tag: DocumentTagDataModel) {
    this.fileService.removeDocumentTags(this.document.DocumentID, [tag.DocumentTagID]).subscribe((res) => {
      if (tag.enumDocumentTagID.toUpperCase() === DOC_TAG_PATIENT_PIC) {
        this.globals.ThePatient.patientImageUrl = '';
        this.globals.save();
        this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', { patientId: this.globals.currentPatientId });
      }
      const idx = this.document.dataDocumentTags.findIndex(p => p.DocumentTagID === tag.DocumentTagID);
      if (idx > -1) {
        this.document.dataDocumentTags.splice(idx, 1);
      }
    });
  }

  saveTags(tagIdsToSave: string[]) {
    if (tagIdsToSave && tagIdsToSave.length > 0) {
      this.fileService.addMultiDocumentsTags([this.document.DocumentID], tagIdsToSave).subscribe((res) => {
        if (res && res.length > 0) {
          // this.document.dataDocumentTags = this.document.dataDocumentTags.concat(res);

          for (const t of res) {
            if (!this.document.dataDocumentTags.find(p => p.enumDocumentTag.ValidValueItemId === t.enumDocumentTag.ValidValueItemId)) {
              this.document.dataDocumentTags.push(t);
            }
            if (!this.imageCategoryIds.includes(t.enumDocumentTagID)) {
              this.imageCategoryIds.push(t.enumDocumentTagID);
            }
          }
          if (tagIdsToSave.map(x => x.toUpperCase()).includes(DOC_TAG_PATIENT_PIC)) {
            this.globals.ThePatient.patientImageUrl = this.document.DocumentFileName;
            this.globals.save();
            this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', { patientId: this.globals.currentPatientId });
          }
          const pid = { patientId: this.globals.currentPatientId };
          this.signalrService.messageSingleUser(this.authServer.currentUserValue.authdata.userid, SignalrService.UPDATE_DOCUMENT, pid);
          this.signalrService.messageAllUsers(SignalrService.UPDATE_DOCUMENT, pid);
          this.notifyLandingWindowPrePostRefresh();
        }
      });
    }
    /*this.fileService.addDocumentTag(this.document.DocumentID, tagIdsToSave).subscribe((res) => {
      this.document.dataDocumentTags = res;
    });*/
  }

  getDate(dateString: string) {
    if (dateString) {
      return new Date(dateString).toLocaleDateString();
    }
    return '';
  }

  onCaseToothSelectionChange(event: any) {
    let persistentSelectedTeethIds = [];
    if (!this.xImage.selectedTeeth) {
      this.xImage.selectedTeeth = [];
    }
    const newSelectedTeeth = event as CaseTooth[];
    const newTeethIds = newSelectedTeeth.map(p => p.CaseWorkItemToothId);
    if (this.xImage.selectedTeeth) {
      persistentSelectedTeethIds = this.xImage.selectedTeeth.map(p => p.CaseWorkItemToothId);
    }

    const newTeeth = newSelectedTeeth.filter(p => !persistentSelectedTeethIds.includes(p.CaseWorkItemToothId));
    const deleteTeeth = this.xImage.selectedTeeth.filter(p => !newTeethIds.includes(p.CaseWorkItemToothId));

    for (const t of newTeeth) {
      const model = new DocumentGroupCreationModel();
      model.ParentObjectName = 'dataPatientCaseWorkItemTeeth';
      model.ObjectId = t.CaseWorkItemToothId;
      model.documentIds = [this.xImage.DocumentId];
      model.PatientId = this.globals.currentPatientId;
      this.fileService.createDocumentGroup(model).subscribe((res) => {
        //
        this.xImage.selectedTeeth.push(t);
      });
    }

    if (deleteTeeth && deleteTeeth.length > 0) {
      this.fileService.deleteDocumentGroupsByObjectIds(this.xImage.DocumentId, deleteTeeth.map(p => p.CaseWorkItemToothId)).subscribe(() => { });
    }

    this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, {});
  }

  openDialogEditTeeth() {
    if (!this.globals.currentPatientCaseWorkItemID || this.globals.currentPatientCaseWorkItemID === '00000000-0000-0000-0000-000000000000') {
      return;
    }
    // open a window to add a new procedure form to this case
    const toothConfig = new ToothPickerConfigModel();
    toothConfig.isMultiSelect = true;
    const teeeth: ToothConfigurationModel[] = [];
    for (const tt of this.toothDetailList) {
      const toot = new ToothConfigurationModel();
      toot.ToothId = tt.ToothId;
      // toot.Notation = toot.cfgToothDescriptions[0].Notation;
      teeeth.push(toot);
    }
    toothConfig.selectedTeeth = teeeth;
    const dialogRef = this.dialog.open(ToothPickerComponent, {
      panelClass: 'dialog',
      data: toothConfig
    });
    dialogRef.afterClosed().subscribe((result) => {

      // array of teeth
      const teeth: cfgTooth[] = [];
      const toothUI: ToothUiManagerModel[] = result;

      toothUI.forEach(a => {
        teeth.push(a.toothModel);
      });

      this.caseService.setCaseWorkItemTeeth(this.globals.currentPatientCaseWorkItemID, teeth)
        .subscribe((response) => {
          this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, {});
          /*toothUI.forEach(a => {
            const ct = new CaseTooth();
            ct.ToothId = a.toothModel.ToothId;
            ct.CaseWorkItemToothId = a.toothMo
            this.toothDetailList.push(ct);
            teeth.push(a.toothModel);
          });*/



          for (const t of response) {
            const ct = new CaseTooth();
            ct.CaseWorkItemToothId = t.CaseWorkItemToothId;
            ct.ToothId = t.ToothID;
            ct.Notation = t.Notation;
            this.toothDetailList.push(ct);
            this.xImage.selectedTeeth.push(ct);

            const model = new DocumentGroupCreationModel();
            model.ParentObjectName = 'dataPatientCaseWorkItemTeeth';
            model.ObjectId = t.CaseWorkItemToothId;
            model.documentIds = [this.xImage.DocumentId];
            model.PatientId = this.globals.currentPatientId;
            this.fileService.createDocumentGroup(model).subscribe((res) => {
              //
              this.toothSelectorUpdate.emit();
              setTimeout(() => {
                this.getAssociatedTeeth();
              }, 500);
            });
          }
          //const i = 0;

        }, err => {
          // this.showMessage('Error', 'Problem updating teeth for procedure');
        });
    }, err => {
      // this.loadData();
    });
  }

  onImageDoubleClick(event: MouseEvent) {
    // console.log('IS THIS FIRING????? EEHHHH?');
    this.imageDoubleClicked.emit(true);
    window.opener.focus();
    window.opener.window.focus();
  }
  // private automation_onShowContextMenu(sender: any, e: lt.Annotations.Automation.AnnAutomationEventArgs) {
  private automation_onShowContextMenu(sender: any, e: lt.Demos.Viewer.ContextEventArgs) {
    // get the automation object and select the object under the current pointer position
    const automation = this.automation;
    const automationControl = automation.automationControl;

    const container = automation.container;
    let point = e.eventArgs.position.clone();
    point = container.mapper.pointToContainerCoordinates(point);
    const objects = container.hitTestPoint(point); // perform the hit test
    if (objects != null && objects.length > 0) { // if we hit an object, select it and then show the properties
      // console.log('object hit ');
      this.contextmenu = true;
      if (automation.currentEditObject instanceof lt.Annotations.Engine.AnnPolyRulerObject) {
        this.isRuler = true;
        const rulerObj: lt.Annotations.Engine.AnnPolyRulerObject = automation.currentEditObject;
        // Get the length of the ruler
        const point1: lt.LeadPointD = rulerObj.points.item(0);
        const point2: lt.LeadPointD = rulerObj.points.item(1);
        const length: number = Math.sqrt(Math.pow(Math.abs(point2.x - point1.x), 2) + Math.pow(Math.abs(point2.y - point1.y), 2));
        this.sourceLength = length;
        // this.sourceLength = automation.currentEditObject.getRulerLength(this.imageViewer.get_screenDpi().width / this.imageViewer.get_screenDpi().height).value;
        // const rulerLengthStr = automation.currentEditObject.getRulerLengthAsString(this.imageViewer.get_screenDpi().width / this.imageViewer.get_screenDpi().height);
        // const rulerLengthStr = rulerObj.getRulerLengthAsString(this.imageViewer.get_screenDpi().width / this.imageViewer.get_screenDpi().height);
        const rulerLengthStr = rulerObj.getRulerLengthAsString(container.mapper.calibrationScale);
        const indexOfSpace = rulerLengthStr.indexOf(' ');
        this.rulerLength = +rulerLengthStr.substring(0, indexOfSpace);
        // console.log('sourceLenghth ' + this.sourceLength);
        // console.log('rulerLengthStr ' + rulerLengthStr);
        // console.log('this.rulerLength ' + this.rulerLength);
      }
      else {
        this.isRuler = false;
      }
      if (automation.currentEditObject == null) {
        const targetObject = objects[objects.length - 1];
        automation.selectObject(targetObject);
      }
      automationControl.automationInvalidate(lt.LeadRectD.empty);

      if (automation.canShowProperties) {
        e.eventArgs.isHandled = true;
        setTimeout(() => {
          // Set a timeout so we escape the right-click event
          automation.showObjectProperties();
        }, 50);
        // this._shownDialogOnce = true;
      }
    }
  }

  private contextMenu_deleteBtn_Click(e: MouseEvent) {
    // console.log('deleteBtn selected');
  }

  // disables the menu
  disableContextMenu() {
    this.contextmenu = false;
  }
  // activates the menu with the coordinates
  onrightClick(event: MouseEvent) {
    this.contextmenuX = event.offsetX;
    this.contextmenuY = event.offsetY;
  }
  onImagingContextMenu(event: any) {

    switch (event) {
      case 'delete':
        if (this.automation.canDeleteObjects) {
          this.automation.deleteSelectedObjects();
          this.contextmenu = false;
        }
        break;
      case 'calibrate':
        this.openCalibrationUI();
        break;
    }
  }

  openCalibrationUI() {
    if (!this.isCalibrationInfoAvailable) {
      // alert('No device recorded with the image.');
      this.dialogService.openConfirmDialog('No device attached with the image.',
        false, false, 'No Device').subscribe((result) => {
          if (result === true) {
          }
        });
      return;
    }
    const dialogRef = this.dialog.open(ImagingCalibrationComponent, {
      width: '350px',
      height: '350px',
      panelClass: 'dialog',
      data: {
        deviceId: this.xImage.deviceId,
        rulerLength: this.rulerLength,
        sourceLength: this.sourceLength
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCalibrationData();
    }, err => {
      // Error
    });
  }
  calibrate() {
    // console.log('inside calibrate ... ');
    if (this.rulerLength && this.sourceLength) {
      const container: lt.Annotations.Engine.AnnContainer = this.automation.container;
      // console.log('calibrating ... ');
      container.mapper.calibrate(
        lt.LeadLengthD.create(this.sourceLength),
        lt.Annotations.Engine.AnnUnit.unit,        // Source unit (container units)
        lt.LeadLengthD.create(this.rulerLength),              // Destination length
        lt.Annotations.Engine.AnnUnit.millimeter); // Destination unit
      /*AnnContainerMapper.prototype.calibrate(lt.LeadLengthD.create(this.sourceLength), lt.Annotations.Engine.AnnUnit.unit,
        lt.LeadLengthD.create(this.rulerLength), lt.Annotations.Engine.AnnUnit.millimeter);*/
      // console.log('done calibrating ... ');
      this.automation.invalidate(lt.LeadRectD.empty);
    }
  }
  noCalibrationFound() {
    // console.log('inside noCalibrationFound ... ');
    const container: lt.Annotations.Engine.AnnContainer = this.automation.container;
    // console.log('calibrating ... ');
    lt.Annotations.Engine.AnnUnitConverter.customUnitPerInch = 1;
    lt.Annotations.Engine.AnnUnitConverter.customUnitAbbreviation = 'No Calibration';
    container.mapper.calibrate(
      lt.LeadLengthD.create(100),
      lt.Annotations.Engine.AnnUnit.unit,        // Source unit (container units)
      lt.LeadLengthD.create(1),              // Destination length
      lt.Annotations.Engine.AnnUnit.customUnit); // Destination unit
    /*AnnContainerMapper.prototype.calibrate(lt.LeadLengthD.create(this.sourceLength), lt.Annotations.Engine.AnnUnit.unit,
      lt.LeadLengthD.create(this.rulerLength), lt.Annotations.Engine.AnnUnit.millimeter);*/
    // console.log('done calibrating ... ');
    this.automation.invalidate(lt.LeadRectD.empty);
  }
  calibrateLeadtools() {
    const container: lt.Annotations.Engine.AnnContainer = this.automation.container;
    const inch: number = 720;
    const rulerObj: lt.Annotations.Engine.AnnPolyRulerObject = new lt.Annotations.Engine.AnnPolyRulerObject();
    rulerObj.points.add(lt.LeadPointD.create(1 * inch, 1 * inch));
    rulerObj.points.add(lt.LeadPointD.create(2 * inch, 1 * inch));
    rulerObj.stroke = lt.Annotations.Engine.AnnStroke.create(lt.Annotations.Engine.AnnSolidColorBrush.create('red'), lt.LeadLengthD.create(1));
    rulerObj.showGauge = true;
    rulerObj.showTickMarks = true;
    rulerObj.measurementUnit = lt.Annotations.Engine.AnnUnit.millimeter;
    container.children.add(rulerObj);

    // Show the ruler
    this.automation.invalidate(lt.LeadRectD.empty);
    alert('Ruler to calibrate, length is 1 inch');

    // Get the length of the ruler
    const point1: lt.LeadPointD = rulerObj.points.item(0);
    const point2: lt.LeadPointD = rulerObj.points.item(1);
    const length: number = Math.sqrt(Math.pow(Math.abs(point2.x - point1.x), 2) + Math.pow(Math.abs(point2.y - point1.y), 2));

    // Calibrate the container mapper
    container.mapper.calibrate(
      lt.LeadLengthD.create(length),           // Source length
      lt.Annotations.Engine.AnnUnit.unit,        // Source unit (container units)
      lt.LeadLengthD.create(6.5),              // Destination length
      lt.Annotations.Engine.AnnUnit.millimeter); // Destination unit

    // Use the Centimeters as the measurement unit in the ruler
    rulerObj.measurementUnit = lt.Annotations.Engine.AnnUnit.millimeter;

    // Now rulerObj should show 6.5 Centimeter as its length
    this.automation.invalidate(lt.LeadRectD.empty);
  }

  getCalibrationData() {
    this.devsService.getDevices(this.globals.LOCID).subscribe((data) => {
      if (data.length > 0) {
        this.deviceList = data;
        if (this.xImage.deviceId) {
          const device = data.find(p => p.enumDeviceSBID === this.xImage.deviceId);
          console.log('TWAIN calibration: deviceId=', this.xImage.deviceId, 'device found=', !!device);
          if (device && device.CalibrationJSON) {
            this.isCalibrationInfoAvailable = true;
            this.getCalibrationFromJSON(device.CalibrationJSON);
            this.calibrate();
          }
        }
        else {
          // if deviceId is null check the db
          if (this.xImage.DocumentId !== null) {
            this.fileService.getDocument(this.xImage.DocumentId).subscribe((res) => {
              this.xImage.deviceId = res.DeviceID;
              if (this.xImage.deviceId) {
                const device = this.deviceList.find(p => p.enumDeviceSBID === this.xImage.deviceId);
                // const device = this.deviceList.find(p => p.DeviceID === this.xImage.deviceId);
                if (device) {
                  if (device.CalibrationJSON) {
                    this.isCalibrationInfoAvailable = true;
                    this.getCalibrationFromJSON(device.CalibrationJSON);
                    this.calibrate();
                  }
                }
              }
            });
            // console.log('calibration not found');
            this.noCalibrationFound();
            this.isCalibrationInfoAvailable = false;
          }
        }
      }
    }, err => {
      // console.log(err);
    });

  }
  getCalibrationFromJSON(paramJson: string) {
    this.calibrationParam = JSON.parse(paramJson);
    // console.log('this.calibrationParam.rulerLength' + this.calibrationParam.rulerLength);
    // console.log('this.calibrationParam.sourceLength' + this.calibrationParam.sourceLength);
    this.rulerLength = this.calibrationParam.rulerLength;
    this.sourceLength = this.calibrationParam.sourceLength;
  }
  // Leadtools Image Processing
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  imageProcessingLeadtools(ipName: string, path: string, model: TDOxImage = null, isRotate180 = false) {
    const ipComplete = (sender: any, e: lt.ImageProcessingCompletedEventArgs) => {
      sender.abort();
      if (e.imageData) {

        const ctx: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
        const imageData = e.imageData;
        // After applying image processing on a temp canvas,  we need to put the image data back onto the dialog canvas
        ctx.putImageData(imageData, 0, 0);
        if (isRotate180) {
          this.imageProcessingLeadtoolsRotate180('Reverse', path, model);
        }
        else {
          this.imageViewer.invalidate(lt.LeadRectD.empty);
        }
      }
    };

    if (!ipName) {
      const image = new Image();
      this.originalCanvas = lt.Demos.Utils.UI.cloneCanvas(this.imageViewer.canvas);
      this.originalImageData = this.originalCanvas.toDataURL('image/png');

      image.src = this.originalImageData;
      const context: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      // context.drawImage(this._originalCanvas, 0, 0);
      this.imageViewer.invalidate(lt.LeadRectD.empty);
      return;
    }

    if (Globals.imageProcessingInstance != null && Globals.imageProcessingInstance.isRunning) {
      Globals.imageProcessingInstance.abort();
      return;
    }
    const ctx: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
    const imageProcessing: lt.ImageProcessing = new lt.ImageProcessing();
    imageProcessing.jsFilePath = path;
    // imageProcessing.jsFilePath = jsMainFilePath;
    imageProcessing.command = ipName;
    if (ipName === 'Grayscale') {
      imageProcessing.arguments['Bits Per Pixel'] = 16;
    }
    // if (ipName === 'Rotate') {
    //   imageProcessing.arguments['rotateAngle'] = 90;
    // }
    const imageData = ctx.getImageData(0, 0, this.imageViewer.canvas.width, this.imageViewer.canvas.height);
    // console.log("ImageData 2");
    imageProcessing.imageData = imageData;
    imageProcessing.completed.add(ipComplete);
    if (!imageData) {
      console.warn('imageProcessingLeadtools: imageData is null, skipping processing');
      return;
    }
    imageProcessing.run();
  }

  imageProcessingLeadtoolsRotate180(ipName: string, path: string, model: TDOxImage = null) {
    const ipComplete = (sender: any, e: lt.ImageProcessingCompletedEventArgs) => {
      sender.abort();
      if (e.imageData) {

        const ctx: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
        const imageData = e.imageData;
        // After applying image processing on a temp canvas,  we need to put the image data back onto the dialog canvas
        ctx.putImageData(imageData, 0, 0);
        this.imageViewer.invalidate(lt.LeadRectD.empty);
      }
    };

    if (!ipName) {
      const image = new Image();
      this.originalCanvas = lt.Demos.Utils.UI.cloneCanvas(this.imageViewer.canvas);
      this.originalImageData = this.originalCanvas.toDataURL('image/png');

      image.src = this.originalImageData;
      const context: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      // context.drawImage(this._originalCanvas, 0, 0);
      this.imageViewer.invalidate(lt.LeadRectD.empty);
      return;
    }

    if (Globals.imageProcessingInstance != null && Globals.imageProcessingInstance.isRunning) {
      Globals.imageProcessingInstance.abort();
      return;
    }
    const ctx: CanvasRenderingContext2D = this.imageViewer.canvas.getContext('2d');
    const imageProcessing: lt.ImageProcessing = new lt.ImageProcessing();
    imageProcessing.jsFilePath = path;
    // imageProcessing.jsFilePath = jsMainFilePath;
    imageProcessing.command = ipName;
    if (ipName === 'Grayscale') {
      imageProcessing.arguments['Bits Per Pixel'] = 16;
    }
    // if (ipName === 'Rotate') {
    //   imageProcessing.arguments['rotateAngle'] = 90;
    // }
    const imageData = ctx.getImageData(0, 0, this.imageViewer.canvas.width, this.imageViewer.canvas.height);
    // console.log("ImageData 2");
    imageProcessing.imageData = imageData;
    imageProcessing.completed.add(ipComplete);
    if (!imageData) {
      console.warn('imageProcessingLeadtoolsRotate180: imageData is null, skipping processing');
      return;
    }
    imageProcessing.run();
  }

  openChangeDateDialog() {
    const dialogRef = this.dialog.open(ChangeImageDateDialogComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'dialog',
      data: {
        message: 'Use this Image Date',
        documentId: this.document.DocumentID,
        ParentDocumentID: this.xImage.thumbDocId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Confirmed
        this.document.DocumentCreateDate = result;
        // Keep xImage.createDate in sync too - this is what the regular Save flow
        // (saveToTdoFileSystem/uploadDocuments) actually reads when building its upload
        // payload, so without this the corrected date never reaches a subsequent Save.
        this.xImage.createDate = result;
      }
    }, err => {
      // Error
    });
  }


}

export interface Item {
  id: number;
  name: string;
}
